// ArChat Auto-Normalized File
// Created: 12-03-2026 22:38:36
// Author: SIVOL® - Aldo Frias - Argentina

/**
 * Autor: SIVOL® - Aldo Frias - Argentina
 * Fecha: 11/03/2026 22:50 (Argentina - UTC-3)
 * Translations for KO
 * @file translations.ko.js
 * @description Main application translations for ko
 * @version v3.1.0
 */

import { PRESET_LOCALES } from '../presencePresetI18n.js';

export const translationsKo = {
                'login.title': '로그인',
                'login.slogan': '국경 없는 대화!',
                'login.username': '사용자 이름',
                'login.password': '비밀번호',
                'login.submit': '로그인',
                'login.loading': '로딩 중...',
                'login.autoRegister.title': '자동 등록',
                'login.autoRegister.description': '계정이 없으면 사용자 이름과 비밀번호를 입력하세요. 자동으로 생성됩니다.',
                'login.forgotPassword': '비밀번호를 잊으셨나요?',
                'login.passwordRecovery.title': '비밀번호 복구',
                'login.passwordRecovery.description': '이메일을 입력하여 복구 링크를 받으세요.',
                'login.passwordRecovery.emailLabel': '이메일',
                'login.passwordRecovery.emailPlaceholder': '이메일을 입력하세요',
                'login.passwordRecovery.emailHelp': '복구 링크가 이메일로 전송됩니다',
                'login.passwordRecovery.send': '보내기',
                'login.passwordRecovery.success': '복구 링크가 이메일로 전송되었습니다. 받은 편지함을 확인하세요.',
                'login.passwordRecovery.successTitle': '이메일 발송됨',
                'login.passwordRecovery.successMessage': '비밀번호 재설정 안내 이메일을 보냈습니다.\n받은편지함과 스팸 폴더를 확인하세요. 링크가 도착하는 데 몇 분 걸릴 수 있습니다.',
                'login.passwordRecovery.devExplanation': '개발 모드에서는 이메일이 받은편지함으로 발송되지 않으며 미리보기용으로 저장됩니다. 「이메일 보기」에서 내용과 복구 링크를 확인하세요.',
                'login.passwordRecovery.devSinkNotice': '⚠️ 개발 모드: 이 이메일은 받은편지함으로 발송되지 않았습니다. 「이메일 보기」에서 생성된 메시지와 링크를 열어보세요.',
                'login.passwordRecovery.invalidEmail': '유효한 이메일 주소를 입력하세요',
                'login.error.invalidPassword': '잘못된 비밀번호',
                'common.language': '언어',
                'common.loading': '로딩 중…',
                'common.back': '뒤로',
                'common.backToStart': '홈으로 돌아가기',
                'common.changeUser': '사용자 변경',
                'common.request_id_label': '요청 ID',
                'login.email.invalid': '유효한 이메일 주소를 입력하세요',
                'captcha.solve': 'CAPTCHA를 올바르게 풀어주세요',
                'captcha.generateError': 'CAPTCHA 생성 오류. 페이지를 새로고침하세요.',
                'auth.require_email': '등록을 완료하려면 이메일이 필요합니다. 이메일을 입력하세요.',
                'auth.invalid_credentials': '사용자 이름 또는 비밀번호가 올바르지 않습니다.',
                'auth.account_blocked': '계정이 비활성화되었습니다. 이메일을 입력하여 재활성화하세요.',
                'auth.device_limit_reached': '디바이스 제한에 도달했습니다. 다른 디바이스에서 로그아웃하거나 요금제를 업그레이드하세요.',
                'auth.login.device_limit.title': '세션 또는 기기 한도 도달',
                'auth.login.device_limit.body': '요금제에 허용된 동시 활성 세션 또는 기기 수가 제한되어 있습니다. 로그인하려면 다른 기기에서 로그아웃하거나 다른 활성 세션을 종료한 뒤 다시 시도하세요.',
                'auth.password_incorrect': '비밀번호가 올바르지 않습니다.',
                'auth.login.password_error_title': '잘못된 비밀번호',
                'auth.login.password_attempts_hint': '비밀번호를 올바르게 입력할 수 있는 기회는 3번입니다. 이를 초과하면 비밀번호를 재설정해야 합니다.',
                'auth.login.password_attempts_exhausted_title': '시도 한도에 도달했습니다',
                'auth.login.password_attempts_exhausted_body': '허용된 3회 시도를 초과했습니다. 계속하려면 «비밀번호를 잊으셨나요?»에서 비밀번호를 재설정하세요.',
                'auth.login.go_to_reset_password': '비밀번호 재설정으로 이동',
                'auth.login.password_remaining_two': '남은 시도는 2회입니다.',
                'auth.login.password_remaining_one': '남은 시도는 1회입니다.',
                'auth.login.password_attempts_locked_inline': '최대 시도 횟수에 도달했습니다. 비밀번호를 재설정해야 합니다.',
                'auth.account_inactive_email_mismatch': '계정이 비활성화되었고 이메일이 일치하지 않습니다.',
                'auth.captcha_failed': 'CAPTCHA가 올바르지 않습니다. 답을 확인하세요.',
                'auth.captcha_expired': '인증이 만료되었습니다. 새 인증이 자동으로 생성되었습니다.',
                'auth.unauthorized': '액세스 권한이 없습니다.',
                'auth.generic_error': '오류가 발생했습니다. 다시 시도하세요.',
                'auth.method_not_allowed': '허용되지 않은 메서드입니다.',
                'auth.invalid_data': '잘못된 데이터입니다.',
                'auth.credentials_required': '사용자 이름과 비밀번호가 필요합니다.',
                'auth.csrf_invalid': '세션이 유효하지 않습니다. 페이지를 새로고침한 후 다시 시도하세요.',
                'auth.username_taken': '해당 사용자 이름은 이미 등록되어 있습니다. 로그인하거나 다른 이름을 선택하세요.',
                'auth.username_unavailable': '해당 사용자 이름을 사용할 수 없습니다.',
                'auth.nick_no_spaces': 'Nicknames cannot contain spaces.',
                'auth.password_too_short': '비밀번호는 최소 6자 이상이어야 합니다.',
                'auth.rate_limit': '시도 횟수가 너무 많습니다. 잠시 후 다시 시도하세요.',
                'auth.confirm_success': '계정이 성공적으로 확인되었습니다. 로그인 페이지로 이동하는 중...',
                'auth.confirm_already_active': '계정이 이미 활성화되어 있습니다. 로그인할 수 있습니다.',
                'auth.reset_sent': '해당 이메일이 등록된 경우 비밀번호 재설정 안내를 받으실 수 있습니다.',
                'auth.reset_token_invalid': '잘못되었거나 만료된 링크입니다.',
                'auth.reset_token_expired': '이 링크는 만료되었습니다. "비밀번호를 잊으셨나요?"에서 새 링크를 요청하세요.',
                'auth.reset_done': '비밀번호가 변경되었습니다. 이제 로그인할 수 있습니다.',
                'auth.reset_fatal': '저장 중 오류가 발생했습니다. 나중에 다시 시도하세요.',
                'auth.password_mismatch': '비밀번호가 일치하지 않습니다.',
                'resetPassword.page.title': '새 비밀번호',
                'resetPassword.page.description': '새 비밀번호를 입력하세요(6자 이상).',
                'resetPassword.newPassword': '새 비밀번호',
                'resetPassword.newPasswordPlaceholder': '6자 이상',
                'resetPassword.submit': '비밀번호 재설정',
                'resetPassword.success': '비밀번호가 변경되었습니다. 로그인으로 이동합니다...',
                'resetPassword.backToLogin': '로그인으로 돌아가기',

                'account.delete.section_title': '계정 삭제',
                'account.delete.description': '계정을 삭제하면 모든 데이터, 메시지, 연락처 및 설정이 영구적으로 제거됩니다. 이 작업은 취소할 수 없습니다.',
                'account.delete.button': '내 계정 삭제',
                'accountDeletion.title': '계정 및 데이터 삭제',
                'accountDeletion.description': 'ArChat 계정 및 관련 데이터 삭제를 요청하세요.',
                'accountDeletion.openRequest': '계정 및 데이터 삭제 요청',
                'account.delete.confirm_title': '계정 삭제',
                'account.delete.confirm_message': '정말 계정을 삭제하시겠습니까? 받은편지함으로 확인 이메일이 전송됩니다. 삭제는 영구적이며 되돌릴 수 없습니다.',
                'account.delete.email_sent_title': '이메일 전송됨',
                'account.delete.email_sent': '확인 이메일을 보냈습니다. 받은편지함을 확인하고 링크를 클릭하여 삭제를 확인하세요.',
                'account.delete.error': '요청을 처리할 수 없습니다. 다시 시도하세요.',
                'account.delete.confirm_page_title': '계정 삭제 확인',
                'account.delete.confirm_page_desc': 'ArChat 계정을 영구적으로 삭제하려고 합니다. 모든 데이터, 메시지, 연락처 및 설정이 제거됩니다. 이 작업은 취소할 수 없습니다.',
                'account.delete.confirm_final_button': '예, 내 계정을 영구적으로 삭제합니다',
                'account.delete.cancel_go_back': '취소하고 돌아가기',
                'account.delete.done_title': '계정이 삭제되었습니다',
                'account.delete.done_message': '계정이 성공적으로 삭제되었습니다. 모든 데이터가 제거되었습니다.',
                'account.delete_token_expired': '삭제 링크가 만료되었거나 더 이상 유효하지 않습니다. 프로필에서 새 링크를 요청하세요.',
                'account.delete_token_invalid': '유효하지 않거나 누락된 삭제 링크입니다.',
                'account.delete_email_failed': '확인 이메일을 보낼 수 없습니다. 나중에 다시 시도하세요.',
                'account.delete_error': '삭제 처리 중 오류가 발생했습니다. 나중에 다시 시도하세요.',

                'auth.register_success_email_sent': '계정이 생성되었습니다. 확인 이메일을 보냈습니다. 받은편지함(및 스팸 폴더)을 확인하고 링크를 클릭하여 계정을 활성화하세요.',
                'auth.register_success_email_pending': '계정이 생성되었으나 확인 이메일 전송에 실패했습니다. 활성화 토큰은 여전히 유효합니다. 관리자에게 문의하거나 새 확인 이메일을 요청하세요.',
                'auth.email_not_verified': '계정을 활성화하려면 이메일을 확인해 주세요.',
                'auth.email_not_verified_title': '계정 확인 대기 중',
                'auth.email_send_failed': '이메일을 보낼 수 없습니다. 다시 시도하거나 이메일을 변경하세요.',
                'auth.email_send_failed_title': '이메일을 보낼 수 없습니다',
                'auth.register.email_failed.title': '계정이 생성되었습니다',
                'auth.register.email_failed.message': '계정이 성공적으로 생성되었지만 확인 이메일 전송에 문제가 있었습니다. 스팸함을 확인하거나 새 이메일을 요청하세요.',
                'auth.register.success.title': '계정이 생성되었습니다',
                'auth.register.success.message': '계정이 성공적으로 생성되었습니다. 확인 이메일을 보냈습니다. 받은편지함(및 스팸 폴더)을 확인하고 링크를 클릭하여 계정을 활성화하세요.',
                'auth.resend_sent': '확인 이메일을 다시 보냈습니다.',
                'auth.resend_email': '이메일 다시 보내기',
                'auth.retry_resend': '다시 시도',
                'auth.change_email': '이메일 변경',
                'auth.ver_email': '이메일 보기',
                'auth.already_verified': '계정이 이미 확인되었습니다.',
                'auth.confirm_email_title': '이메일 확인',
                'auth.confirm_email_text': '활성화 링크가 다음으로 전송됩니다:',
                'auth.confirm_email_edit': '편집',
                'auth.confirm_email_confirm': '확인',
                'auth.confirm_email_typo_hint': '***@{suggestion} (으)로 하시겠습니까?',
                'brand.slogan': '언어와 상관없이 이해받는 힘',
                "brand.appName": "ArChat®",
                "brand.name": "ArChat®",
                "home.title": "ArChat®",
                'home.slogan': '언어와 상관없이 이해받는 힘',
                'home.tagline': '자동 번역 메시징',
                'home.login': '로그인',
                'home.register': '계정 만들기',
                'home.language': '언어',
                'terms.title': '이용약관',
                'terms.accept': '수락하고 계속',
                'terms.reject': '거부',
                'terms.rejectShort': '동의하지 않음',
                'terms.readAndAccept': '이용약관을 읽고 동의했습니다',
                'terms.cancel': '취소',
                'register.pageTitle': '계정 만들기',
                'register.pageSubtitle': '정보를 입력해 계정을 만드세요.',
                'register.submitLabel': '계정 만들기',
                'register.confirm_title': '계정 확인',
                'register.confirm_message': '다음 계정을 생성합니다:',
                'register.confirm': '확인',
                'register.login_link': '이미 계정이 있으신가요?',
                'register.password_hint': '6자 이상',
                'register.checking': '확인 중…',
                'register.username_taken': '이 사용자 이름은 이미 사용 중입니다.',
                'register.available': '사용 가능',
                'register.emailAlreadyExists': '이 이메일은 이미 등록되어 있습니다.',
                'register.continue': '계속',
                'login.demo.title': '데모 액세스',
                'login.demo.credentials': '사용자: demo / 비밀번호: demo',
                'captcha.label': '보안 확인',
                'security.verification_title': '보안 확인',
                'security.captcha_question': '확인 질문',
                'security.enter_answer': '정답 입력',
                'captcha.description': '수학 연산을 풀어 당신이 인간임을 확인하세요',
                'captcha.required': '계속하려면 CAPTCHA 답을 입력하세요.',
                'menu.conversations': '대화',
                'menu.contacts': '연락처',
                'menu.dashboard': '대시보드',
                'menu.profile': '내 프로필',
                'menu.settings': '설정',
                'menu.help': '도움말',
                'menu.logout': '로그아웃',
                'menu.files': '내 파일',
                'reviews.menu_title': '리뷰',
                'reviews.rate_archat': 'ArChat 평가하기',
                'reviews.my_review': '내 리뷰',
                'navbar.contacts': '연락처',
                'navbar.profile': '내 프로필',
                'navbar.settings': '설정',
                'navbar.logout': '로그아웃',
                'onboarding.welcome_title': 'ArChat®에 오신 것을 환영합니다',
                'onboarding.welcome_subtitle': '어떤 사람과도 어떤 언어로든 소통하세요.',
                'onboarding.step1': '1단계',
                'onboarding.step1_title': '1단계',
                'onboarding.step1_description': '첫 번째 연락처를 초대하세요',
                'onboarding.step2': '2단계',
                'onboarding.step2_title': '2단계',
                'onboarding.step2_description': '첫 메시지를 보내세요',
                'onboarding.invite_contact': '연락처 초대',
                'onboarding.explore_archat': 'ArChat® 둘러보기',
                'contacts.invite_contact': '연락처 초대',
                'contacts.no_contacts': '연락처가 없습니다',
                'help.view_initial_guide': '초기 가이드 보기',
                'suggestions.title': '제안',
                'suggestions.form.title': '제안 제목',
                'suggestions.form.message': '아이디어를 설명해 주세요',
                'suggestions.form.submit': '제안 보내기',
                'suggestions.send': '제안 보내기',
                'suggestions.captcha_placeholder': '결과',
                'suggestions.cooldown': '다음 제안을 보내기 전에 {minutes}분 기다려야 합니다.',
                'suggestions.success_title': '제안이 전송되었습니다',
                'suggestions.success_message': '제안이 성공적으로 전송되었습니다. 추적 번호: {id}',
                'suggestions.success': '제안해 주셔서 감사합니다. 팀에서 검토하겠습니다.',
                'suggestions.success.title': '제안해 주셔서 감사합니다!',
                'suggestions.success.reference': '참조 번호',
                'suggestions.success.review': '팀에서 검토하겠습니다.',
                'suggestions.success.email': '확인 이메일을 보내드렸습니다.',
                'suggestions.success.copy': '복사',
                'suggestions.success.copied': '참조 번호가 복사되었습니다',
                'suggestions.form.required': '제목과 메시지는 필수입니다.',
                'suggestions.error': '전송할 수 없습니다. 다시 시도해 주세요.',
                'profile.title': '내 프로필',
                'profile.founderBadge': '창립자 #{position}/{limit}',
                'profile.founderTooltip': '창립 멤버 – 구독이 유지되는 동안 평생 고정 가격',
                'profile.founderMember': '창립 멤버',
                'profile.founderHeaderBadge': '★ 창립자 #{position}/150',
                'profile.camera.access_denied': '카메라에 액세스할 수 없습니다. 권한을 확인하세요.',
                'profile.edit': '편집',
                'profile.save': '변경 사항 저장',
                'profile.save.success': '프로필이 성공적으로 업데이트되었습니다.',
                'profile.save.success.title': '프로필 업데이트됨',
                'profile.update.success.title': '프로필 업데이트됨',
                'profile.update.success.message': '변경 사항이 저장되었습니다.',
                'profile.save.error': '프로필을 업데이트할 수 없습니다. 다시 시도해주세요.',
                'profile.save.error.title': '저장 오류',
                'profile.cancel': '취소',
                'profile.nick': '사용자 이름',
                'profile.nick.help': '시스템 내 고유 식별자',
                'profile.name': '이름',
                'profile.lastname': '성',
                'profile.alias': '별명',
                'profile.email': '이메일',
                'profile.phone': '전화',
                'profile.language': '언어',
                'profile.country': '국가',
                "profile.country.select": "국가 선택",
                'profile.biography': '전기',
                'bio.modal.original': '원문',
                'bio.modal.translation': '번역',
                'bio.modal.empty': '이 연락처에는 소개가 없습니다.',
                'bio.modal.translating': '번역 중...',
                'bio.modal.translation_error': '소개를 번역할 수 없습니다.',
                'attachment.unnamed_file': '파일',
                'auth.login_error.default_title': '접근 오류',
                'auth.login_error.default_message': '로그인할 수 없습니다.',
                'profile.photo': '프로필 사진',
                'notifications.bell.aria': '알림',
                'notifications.panel.title': '알림',
                'notifications.empty': '알림 없음',
                'notifications.mark_read': '열 때 읽음으로 표시',
                'billing.change_plan': '요금제 변경',
                'billing.usage.title': '플랜 사용량',
                'billing.usage.users': '사용자',
                'billing.usage.messages': '메시지 (오늘)',
                'billing.usage.invitations': '초대 (오늘)',
                'billing.usage.messages_month': '이번 달 메시지',
                'billing.usage.chats': '대화',
                'billing.usage.warning': '플랜 한도에 가까워지고 있습니다. PRO로 업그레이드하여 용량을 늘리세요.',
                'plans.limit.reached': '한도 도달 — 요금제 업그레이드',
                'profile.theme.dark': '다크 모드',
                'profile.theme.light': '라이트 모드',
                'profile.theme.argentina': '아르헨티나 테마',
                'modal.title': '제목',
                'modal.success.title': '성공',
                'modal.error.title': '오류',
                'modal.warning.title': '경고',
                'info.title': '정보',
                'appearance.title': '모양',
                'appearance.theme.light': '라이트',
                'appearance.theme.dark': '다크',
                'theme.title': '테마',
                'theme.light': '라이트',
                'theme.dark': '다크',
                'profile.photo.section': '프로필 사진',
                'profile.personalInfo': '개인 정보',
                'profile.preferences': '기본 설정',
                'profile.country.help': '시간대는 선택한 국가에 따라 자동으로 할당됩니다',
                'profile.lastname.placeholder': '귀하의 성 (선택 사항)',
                'profile.name.placeholder': '귀하의 이름 (선택 사항)',
                'profile.biography.placeholder': '자신에 대해 알려주세요...',
                'profile.notifications.sound': '알림 소리',
                'profile.notifications.sound_desc': '메시지나 중요한 알림이 올 때 소리 재생',
                'profile.plan.title': '구독 플랜',
                'profile.plan.current': '현재 플랜',
                'profile.plan.expires': '만료일',
                'profile.plan.free.description': '기능이 제한된 무료 플랜. 모든 기능을 제한 없이 즐기려면 PRO로 업그레이드하세요.',
                'profile.plan.pro.description': '훌륭합니다! ArChat®의 모든 프리미엄 기능에 완전히 액세스할 수 있습니다.',
                "profile.plan.upgrade.button": "PRO로 업그레이드",
                'profile.plan.upgrade.hint': 'Access all features without limits',
                'profile.photo.change': '프로필 사진 변경',
                'message.placeholder': '메시지 작성...',
                'message.placeholderWithFile': '파일 보내기',
                "message.sent_from_country": "보낸 사람",
                "message.sent_at_local_time": "발행자의 현지 시간",
                "message.timezone_label": "시간대",
                "message.context_info": "이 메시지는 전송된 시간의 시간 컨텍스트를 유지합니다.",
                "message.context_pro_hint": "이 메시지에는 Pro 플랜에서 사용할 수 있는 시간과 지리적 컨텍스트가 있습니다.",
                "message.context_pro_badge": "컨텍스트 프로",
                'message.audio.transcribe': '오디오 전사',
                'message.audio.transcribing': '전사 중...',
                'message.audio.transcription': '전사',
                'message.audio.error': '오디오를 전사할 수 없습니다',
                'attachment.title': '파일 첨부',
                'attachment.close': '닫기',
                'attachment.gallery': '사진/동영상 갤러리',
                'attachment.cameraFront': '전면 카메라',
                'attachment.cameraBack': '후면 카메라',
                'attachment.cameraWeb': '웹캠',
                'attachment.recordAudio': '마이크로 오디오 녹음',
                'attachment.selectFile': '파일 선택 (오디오, 동영상, 텍스트, PDF)',
                'attachment.remove': '제거',
                'attachments.recipientFreeBlocked.title': '플랜 제한',
                'attachments.recipientFreeBlocked.sender': '상대는 Free 요금제라 첨부 파일을 받을 수 없습니다.',
                'attachments.recipientFreeBlocked.receiver': '{senderName}님이 첨부 파일 전송을내려 시도했으나, {planName} 요금제에서는 첨부를 받을 수 없습니다. 파일을 받으려면 상위 요금제로 업그레이드하세요.',
                'attachments.recipientFreeBlocked.upgradeCta': '요금제 업그레이드',
                'audio.title': '오디오 녹음',
                'audio.close': '닫기',
                'audio.ready': '녹음 준비됨',
                'audio.recording': '녹음 중...',
                'audio.finished': '녹음 완료',
                'audio.start': '녹음 시작',
                'audio.stop': '녹음 중지',
                'audio.confirm': '확인 및 전송',
                'audio.rerecord': '다시 녹음',
                'audio.error.microphone': '마이크에 액세스할 수 없습니다. 권한을 확인하세요.',
                'camera.title': '카메라',
                'camera.close': '닫기',
                'camera.switch': '카메라 전환',
                'camera.capture': '사진 촬영',
                'camera.loading': '카메라 시작 중...',
                'camera.retry': '다시 시도',
                'camera.error.access': '카메라에 액세스할 수 없습니다. 권한을 확인하세요.',
                'camera.error.permission': '카메라 권한이 거부되었습니다. 브라우저 설정에서 카메라 액세스를 허용하세요.',
                'camera.error.notFound': '카메라를 찾을 수 없습니다.',
                'camera.error.busy': '카메라가 다른 애플리케이션에서 사용 중입니다.',
                'camera.error.constraint': '카메라 제약 조건을 충족할 수 없습니다.',
                'profile.photo.take': '사진 촬영',
                'profile.photo.gallery': '갤러리에서 선택',
                'profile.photo.uploading': '이미지 업로드 중...',
                'profile.photo.upload.success': '프로필 사진이 성공적으로 업데이트되었습니다',
                'profile.photo.upload.success.title': '사진 업데이트됨',
                'profile.photo.upload.error': '프로필 사진 업로드 중 오류가 발생했습니다. 다시 시도해 주세요.',
                'profile.photo.upload.error.title': '업로드 오류',
                'user.default': '사용자',
                'logout.title': '확인',
                'logout.confirm': '로그아웃하시겠습니까?',
                'contacts.title': '연락처',
                'contacts.search': '연락처 검색',
                'contacts.search.placeholder': '사용자 이름, 이름, 성, 국가 또는 언어로 검색...',
                'contacts.sort': '정렬',
                'contacts.sortByName': '이름순',
                'contacts.sortByStatus': '상태순',
                'contacts.sortByRecent': '최근',
                'contacts.filter': '필터',
                'contacts.filterAll': '전체',
                'contacts.filterAvailable': '사용 가능',
                'contacts.filterInvited': '초대됨',
                'contacts.filterBlocked': '차단됨',
                'contacts.pending_invitations': '대기 중인 초대',
                'contacts.status.invitation_sent': '초대 발송됨',
                'contacts.empty': '연락처가 없습니다',
                'contacts.empty.title': '아직 연락처가 없습니다',
                'contacts.empty.message': '채팅을 시작하려면 연락처를 초대하거나 추가하세요.',
                'contacts.empty.invite_button': '연락처 초대',
                'contacts.empty.private.message': '귀하의 프로필은 비공개입니다. 연락처를 초대하여 채팅을 시작하세요.',
                'contacts.empty.private.invite_button': '연락처 초대',
                'contacts.search.no_results': '연락처를 찾을 수 없습니다',
                'contacts.search.clear': '모두 표시',
                'contacts.controls.search_placeholder': '연락처 검색...',
                'contacts.controls.search_label': '연락처 검색',
                'contacts.controls.sort_label': '정렬 기준',
                'contacts.controls.sort.name': '이름',
                'contacts.controls.sort.status': '상태',
                'contacts.controls.sort.recent': '최근',
                'contacts.controls.sort.manual': '수동',
                'contacts.controls.sort.manual_drag_hint': '드래그하여 순서 변경',
                'contacts.controls.filter_label': '상태',
                'contacts.controls.filter.all': '전체',
                'contacts.controls.filter.available': '사용 가능',
                'contacts.controls.filter.invited': '초대됨',
                'contacts.controls.filter.blocked': '차단됨',
                'contacts.controls.filter.favorites': '즐겨찾기',
                'contacts.nick': '사용자 이름',
                'contacts.name': '이름',
                'contacts.lastname': '성',
                'contacts.country': '국가',
                'contacts.language': '언어',
                'contacts.status': '상태',
                'status.available': '사용 가능',
                'status.busy': '바쁨',
                'status.in_call': '통화 중',
                'status.away': '자리 비움',
                'status.offline': '오프라인',
                'status.custom': '맞춤 메시지',
                'status.set_title': '가용성 상태',
                'status.set_button': '상태 변경',
                'status.placeholder': '선택 메시지 (예: 회의 중)',
                'contacts.status.pending_registration': '등록 대기 중',
                'contacts.status.registered': '초대됨 - 등록됨',
                'contacts.status.ready_to_chat': '채팅 준비됨',
                'contacts.status.active_conversation': '활성 대화',
                'contacts.invitation.pending.title': '대기 중인 초대',
                'contacts.invitation.pending.message': '이 초대는 등록 대기 중입니다. 연락처는 등록을 완료하기 위한 이메일을 받게 됩니다. 등록되면 그들과 채팅할 수 있습니다.',
                'contacts.error.no_registered': '연락처가 아직 등록되지 않았습니다. 등록이 완료될 때까지 기다려주세요.',
                'contact.edit.title': '연락처 편집',
                'contact.edit.alias.label': '사용자 정의 별칭',
                'contact.edit.alias.placeholder': '예: 직장의 존',
                'contact.edit.alias.help': '이 이름이 실제 이름 대신 표시됩니다',
                'contact.edit.nota.label': '개인 메모',
                'contact.edit.nota.placeholder': '이 연락처에 대한 메모 추가...',
                'contact.edit.nota.help': '개인 메모는 귀하에게만 표시됩니다',
                'contact.edit.error.noUser': '오류: 사용자가 식별되지 않았습니다',
                'contact.edit.error.noContactId': '오류: 연락처를 식별할 수 없습니다',
                'contact.edit.error.save': '저장 오류',
                'contact.limit.title': '연락처 한도 도달',
                'contact.limit.message': 'FREE 플랜은 사용자당 최대 2개의 연락처를 허용합니다. 결제가 활성화되면 FOUNDATION 또는 PRO로 업그레이드하여 더 많은 용량을 이용하세요.',
                'contact.edit.info.personalized': '이러한 변경 사항은 귀하에게만 개인화되며 다른 사용자에게는 영향을 주지 않습니다.',
                'contact.edit.profileInfo': '프로필 정보',
                'export.title': '대화 내보내기',
                'export.description': '이 대화를 내보낼 형식을 선택하세요:',
                'export.progress': '내보내는 중...',
                "export.format.pdf": "PDF",
                'export.format.pdf.description': '모든 이미지와 파일이 포함된 PDF 문서',
                "export.format.html": "HTML",
                'export.format.html.description': '모든 브라우저에서 열 수 있는 HTML 파일',
                'export.info': '내보내기에는 이 대화의 모든 메시지, 이미지 및 파일이 포함됩니다.',
                'export.pro_required.title': '대화보내기',
                'export.pro_required.message': '이 기능은 PRO 요금제에서 이용할 수 있습니다.',
                'invitation.title': '이메일로 연락처 초대',
                'invitation.modal.title': '초대 보내기',
                'invitation.modal.description': 'ArChat®에서 누군가를 채팅하도록 초대합니다. 초대를 수락하는 링크가 포함된 이메일을 받게 됩니다.',
                'invitation.email.label': '초대받은 사람의 이메일',
                "invitation.email.placeholder": "ejemplo@email.com",
                'invitation.email.required': '이메일은 필수입니다',
                'invitation.email.invalid': '유효한 이메일을 입력하세요',
                'invitation.language.label': '초대받은 사람의 선호 언어',
                'invitation.language.help': '이메일은 이 언어로 전송됩니다',
                'invitation.mode.label': '대화 모드',
                'invitation.mode.profesional': '전문적',
                'invitation.mode.profesional.description': '공식적이고 전문적인 대화',
                'invitation.mode.tecnico': '기술적',
                'invitation.mode.tecnico.description': '기술적이고 전문적인 대화',
                'invitation.mode.casual': '캐주얼',
                'invitation.mode.casual.description': '비공식적이고 친근한 대화',
                'invitation.message.label': '개인 메시지 (선택사항)',
                'invitation.message.placeholder': '초대받은 사람을 위한 개인 메시지를 작성하세요...',
                'invitation.send': '초대 보내기',
                'invitation.sending': '전송 중...',
                'invitation.success': '초대가 성공적으로 전송되었습니다',
                'invitation.error': '초대 전송 중 오류 발생',
                'invitation.error.self': '자신을 초대할 수 없습니다',
                'invitation.error.duplicate': '이 이메일에 대해 이미 대기 중인 초대가 있습니다',
                'invitation.list.title': '보낸 초대',
                'invitation.list.empty': '초대를 보내지 않았습니다',
                'invitation.list.email': '이메일',
                'invitation.list.language': '언어',
                'invitation.list.mode': '모드',
                'invitation.list.status': '상태',
                'invitation.list.created': '전송됨',
                'invitation.list.expires': '만료',
                'invitation.list.actions': '작업',
                'invitation.status.pending': '대기 중',
                'invitation.status.accepted': '수락됨',
                'invitation.status.expired': '만료됨',
                'invitation.status.cancelled': '취소됨',
                'invitation.copy.link': '링크 복사',
                'invitation.copy.success': '링크가 클립보드에 복사되었습니다',
                'invitation.cancel': '취소',
                'invitation.cancel.confirm': '이 초대를 취소하시겠습니까?',
                'invitation.cancel.success': '초대가 성공적으로 취소되었습니다',
                'invitation.cancel.title': '취소 확인',
                'invitation.resend': '이메일 다시 보내기',
                'invitation.resend.title': '초대 다시 보내기',
                'invitation.resend.success': '초대 이메일이 성공적으로 다시 전송되었습니다',
                'invitation.resend.error': '초대 이메일을 다시 보내는 중 오류가 발생했습니다',
                'invitation.accept.title': '초대 수락',
                'invitation.accept.description': 'ArChat®에서 채팅하도록 초대되었습니다',
                'invitation.accept.inviter': '초대자',
                'invitation.accept.message': '개인 메시지',
                'invitation.accept.login': '로그인',
                'invitation.accept.register': '등록',
                'invitation.accept.error.invalid': '유효하지 않은 초대 토큰',
                'invitation.accept.error.expired': '이 초대는 만료되었습니다',
                'invitation.accept.error.accepted': '이 초대는 이미 수락되었습니다',
                'invitation.accept.error.cancelled': '이 초대는 취소되었습니다',
                'invitation.accept.error.email_mismatch': '계정 이메일이 초대 이메일과 일치하지 않습니다',
                'invitation.accept.success': '초대가 수락되었습니다. 채팅으로 리디렉션 중...',
                'invitations.sent.title': '보낸 초대',
                'invitations.sent.empty': '대기 중인 초대가 없습니다',
                'invitations.pending.title': '대기 중인 초대',
                'invitations.columns.email': '이메일',
                'invitations.columns.language': '언어',
                'invitations.columns.mode': '모드',
                'invitations.columns.status': '상태',
                'invitations.columns.sentAt': '전송됨',
                'invitations.columns.actions': '작업',
                'invitations.status.pending': '대기 중',
                'invitations.status.accepted': '수락됨',
                'invitations.status.cancelled': '취소됨',
                'invitations.status.expired': '만료됨',
                'invitations.actions.cancel': '취소',
                'invitations.actions.copy': '링크 복사',
                'invitations.actions.resend': '이메일 다시 보내기',
                'profile.privacy.title': '개인정보 보호',
                'profile.privacy.public_visibility': '내 프로필을 공개적으로 표시',
                'profile.privacy.public_warning': '이렇게 하면 ArChat®의 모든 사용자가 귀하를 찾아 대화를 시작할 수 있습니다.',
                'profile.privacy.private_info': '귀하의 프로필은 비공개입니다. 귀하가 초대하거나 귀하를 초대한 사용자만 채팅할 수 있습니다.',
                'profile.privacy.private_default': '기본적으로 보안을 위해 프로필은 비공개입니다.',
                'common.close': '닫기',
                'common.cancel': '취소',
                'common.confirm': '확인',
                'common.sending': '전송 중',
                'common.save': '저장',
                'common.saving': '저장 중...',
                'buttons.accept': '수락',
                'buttons.cancel': '취소',
                'buttons.save': '저장',
                'buttons.edit': '편집',
                'buttons.retry': '재시도',
                'buttons.confirm': '확인',
                'buttons.yes': '예',
                'buttons.no': '아니오',
                'buttons.send': '보내기',
                'buttons.close': '닫기',
                'buttons.continue': '계속',
                'buttons.delete': '삭제',
                'buttons.logout': '로그아웃',
                'buttons.back': '뒤로',
                'buttons.update': '업데이트',
                'buttons.upload': '업로드',
                'buttons.select': '선택',
                'conversation.backToContacts': '연락처로 돌아가기',
                'help.title': 'ArChat® 도움말',
                'help.what.title': 'ArChat®란 무엇인가요?',
                'help.what.description': 'ArChat®은 자동 번역 기능이 있는 인스턴트 메시징 시스템으로, 선호하는 언어로 전 세계 사용자와 소통할 수 있습니다. 각 사용자는 자신의 언어로 작성하고 메시지를 자동으로 자신의 언어로 번역하여 받습니다.',
                'help.how.title': '어떻게 작동하나요?',
                'help.how.step1.title': '로그인',
                'help.how.step1.description': '닉네임과 비밀번호를 사용하여 시스템에 액세스합니다. 계정이 없으면 자동으로 생성됩니다.',
                'help.how.step2.title': '연락처 탐색',
                'help.how.step2.description': '"연락처" 섹션으로 이동하여 사용 가능한 모든 사용자를 확인합니다. 이름, 국가 또는 언어로 검색할 수 있습니다.',
                'help.how.step3.title': '대화 시작',
                'help.how.step3.description': '연락처의 상태 또는 이름을 클릭하여 대화를 시작합니다. 시스템이 자동으로 메시지를 번역합니다.',
                'help.how.step4.title': '작성 및 전송',
                'help.how.step4.description': '선호하는 언어로 메시지를 작성합니다. 수신자는 자동으로 자신의 언어로 번역된 메시지를 받습니다.',
                'help.features.title': '주요 기능',
                'help.features.translation': '🌐 언어 간 자동 및 즉시 번역',
                'help.features.status': '💬 온라인 상태 (온라인, 자리 비움, 방해 금지 등)',
                'help.features.statusCustom': '💬 이모지 및 맞춤 메시지가 있는 사용자 정의 상태',
                'help.features.contacts': '👥 검색 및 필터 기능이 있는 완전한 연락처 목록',
                'help.features.contactsMobile': '📱 전체 정보(성, 국가, 상태)가 포함된 최적화된 모바일 보기',
                'help.features.contactsFilter': '👁️ 즐겨찾기가 아닌 연락처 표시/숨기기 버튼 - 목록을 즐겨찾기로만 축소',
                'help.features.contactAlias': '✏️ 각 연락처에 대한 사용자 정의 별칭 및 개인 메모 - 대화에서 연락처 이름 클릭',
                'help.features.themes': '🎨 2가지 사용 가능한 테마: 아르헨티나(연한 파란색/흰색/금색), 다크(진한 보라색)',
                'help.features.messages': '📨 읽음 표시가 있는 실시간 메시징',
                'help.features.attachments': '📎 파일 첨부: 이미지, 비디오, 오디오 및 PDF 문서',
                'help.features.camera': '📸 전면, 후면 카메라 또는 웹캠으로 사진 촬영',
                'help.features.gallery': '🖼️ 갤러리에서 파일 선택',
                'help.features.compression': '🗜️ 자동 이미지 압축 및 썸네일 생성',
                'help.features.progress': '📊 파일 업로드 중 진행 표시줄',
                'help.features.delete': '🗑️ 자신의 메시지 삭제',
                'help.features.scroll': '⬇️ 대화를 열 때 마지막 메시지로 자동 스크롤',
                'help.features.profile': '👤 아바타, 전기 및 기본 설정이 포함된 사용자 정의 가능한 프로필',
                'help.features.profileEdit': '✏️ 중단 없는 프로필 편집 (편집 중 새로고침 없음)',
                'help.features.countries': '🌍 195개 이상의 국가 전체 목록 및 자동 시간대 선택',
                'help.features.registration': '📧 이메일 확인 및 보안 CAPTCHA로 등록',
                'help.features.multilanguage': '🗣️ 여러 언어 지원 (스페인어, 영어, 포르투갈어, 프랑스어, 독일어, 이탈리아어, 러시아어, 중국어, 일본어, 한국어, 아랍어, 힌디어)',
                'help.features.audio': '🎤 자동 텍스트 전사가 있는 음성 메시지 녹음',
                'help.features.speechToText': '📝 Whisper 및 Google Speech API를 사용한 오디오-텍스트 전사',
                'help.features.pwa': '📲 모바일 장치 및 데스크톱에 설치 가능한 PWA 애플리케이션',
                'help.features.sync': '🔄 5초마다 자동 메시지 동기화',
                'help.features.deleteSync': '🗑️ 장치 간 삭제된 메시지 자동 동기화',
                'help.features.notifications': '🔔 새 메시지 수신 시 소리 알림',
                'help.features.retranslation': '🔄 첫 번째 시도가 실패한 경우 자동 메시지 재번역',
                'help.features.preview': '👁️ 전송 전 파일 미리보기',
                'help.features.security': '🔒 CAPTCHA, 브라우저 지문 및 속도 제한이 있는 보안 시스템',
                'help.features.passwordRecovery': '🔑 이메일을 통한 비밀번호 복구',
                'help.features.emailConfirmation': '📧 활성화 링크가 포함된 이메일을 통한 계정 확인',
                'help.features.invitations': '📧 개인 이메일 초대 - 정의된 언어와 컨텍스트로 외부 연락처 초대',
                'help.features.invitationsManagement': '📋 완전한 초대 관리 - 메뉴에서 보류 중인 초대를 나열, 재전송 또는 취소',
                'help.features.contactStatus': '🏷️ 표시 가능한 연락처 상태 - 각 연락처의 상태 확인 (보류 중, 등록됨, 채팅 준비 완료)',
                'help.features.favorites': '⭐ 즐겨찾기 시스템 - 연락처를 즐겨찾기로 표시하여 빠르게 액세스',
                'help.features.profilePhoto': '📸 개선된 프로필 사진 업로드 - 갤러리에서 이미지 선택, 즉시 미리보기',
                'help.features.translationSender': '👁️ 발신자 번역 보기 - 메시지가 수신자의 언어로 어떻게 번역되었는지 확인',
                'help.features.unifiedContacts': '🔗 통합 연락처 모델 - 연락처는 초대 및 기존 대화에서 파생',
                'help.features.privacy': '🔒 기본 개인 모드 - 귀하의 프로필은 개인이며 직접 초대를 통해서만 액세스 가능',
                'help.features.export': '💾 대화 내보내기 - 이미지와 파일이 포함된 전체 대화를 PDF 또는 HTML로 내보내기',
                'help.tips.title': '유용한 팁',
                'help.tips.language': '✅ 프로필에서 선호하는 언어를 설정하여 올바르게 번역된 메시지 수신',
                'help.tips.status': '✅ 온라인 상태를 업데이트하여 다른 사람이 귀하의 가용성을 알 수 있도록 함',
                'help.tips.statusCustom': '✅ 이모지와 메시지로 사용자 정의 상태를 만들어 현재 상태 표현',
                'help.tips.search': '✅ 즐겨찾기(별)를 표시하고 "사용자" 모달에서 사용자 차단',
                'help.tips.contactsFilter': '✅ 상단 바의 눈 버튼(👁️)을 사용하여 즐겨찾기가 아닌 연락처 표시 또는 숨기기',
                'help.tips.contactAlias': '✅ 대화에서 연락처 이름을 클릭하여 사용자 정의 별칭 및 개인 메모 추가',
                'help.tips.avatar': '✅ 연락처의 아바타를 클릭하여 큰 크기의 이미지 보기',
                'help.tips.messages': '✅ 읽지 않은 메시지가 있으면 ArChat® 아이콘이 깜박임',
                'help.tips.attachments': '✅ 클립 버튼(📎)을 사용하여 이미지, 비디오, 오디오 또는 PDF 첨부',
                'help.tips.camera': '✅ 카메라를 사용하여 앱에서 직접 사진 촬영',
                'help.tips.compression': '✅ 이미지는 공간 절약을 위해 자동으로 압축됨',
                'help.tips.delete': '✅ 삭제 버튼을 클릭하여 자신의 메시지 삭제 가능',
                'help.tips.profile': '✅ 걱정 없이 프로필 편집: 편집하는 동안 시스템이 새로고침되지 않음',
                'help.tips.themes': '✅ 설정 > 외관에서 테마 변경: 아르헨티나(연한 파란색), 다크(진한 보라색)',
                'help.tips.country': '✅ 프로필에서 국가를 선택하면 시간대가 자동으로 구성됨',
                'help.tips.registration': '✅ 등록 시 이메일을 확인하여 계정을 완전히 활성화',
                'help.tips.audio': '✅ 마이크 버튼(🎤)을 사용하여 음성 메시지 녹음 - 자동으로 텍스트로 전사됨',
                'help.tips.install': '✅ 장치에 ArChat®을 PWA 애플리케이션으로 설치하여 데스크톱에서 빠르게 액세스',
                'help.tips.sync': '✅ 메시지는 5초마다 자동으로 동기화됩니다 - 새로고침할 필요가 없습니다',
                'help.tips.deleteSync': '✅ 메시지를 삭제하면 수신자의 모든 장치에서 자동으로 삭제됩니다',
                'help.tips.notifications': '✅ 다른 사용자로부터 새 메시지를 받으면 소리가 들립니다',
                'help.tips.retranslation': '✅ 메시지가 올바르게 번역되지 않은 경우 시스템이 자동으로 재번역을 시도합니다',
                'help.tips.preview': '✅ 전송하기 전에 파일을 미리보기하여 올바른지 확인',
                'help.tips.passwordRecovery': '✅ 비밀번호를 잊은 경우 로그인 시 "비밀번호를 잊으셨나요?" 링크를 사용',
                'help.tips.emailConfirmation': '✅ 등록 후 이메일을 확인하고 확인 링크를 클릭',
                'help.tips.languageChange': '✅ 플래그 선택기에서 언제든지 언어 변경 - 즉시 업데이트',
                'help.tips.inputFixed': '✅ PC에서 입력 바는 더 편리하게 화면 하단에 고정됩니다',
                'help.tips.invitations': '✅ 프로필에서 이메일로 연락처 초대 - 처음부터 언어와 대화 모드 정의',
                'help.tips.invitationsManagement': '✅ "보낸 초대" 메뉴에서 초대 관리 - 이메일 재전송 또는 보류 중인 초대 취소',
                'help.tips.contactStatus': '✅ 목록에서 각 연락처의 상태 확인 - 보류 중 (주황색), 등록됨 (녹색) 또는 활성 대화 (파란색)',
                'help.tips.favorites': '✅ 별표 ⭐ 로 연락처를 즐겨찾기로 표시 - 즐겨찾기가 목록 맨 위에 표시됩니다',
                'help.tips.profilePhoto': '✅ "갤러리에서 선택"에서 프로필 사진 업로드 - 저장하기 전에 미리보기가 표시됩니다',
                'help.tips.translationSender': '✅ 메시지를 보낼 때 번역 패널을 확장하여 수신자의 언어로 어떻게 번역되었는지 확인',
                'help.tips.unifiedContacts': '✅ 연락처가 초대를 수락하거나 연락처와 대화가 있을 때 연락처가 자동으로 표시됩니다',
                'help.tips.privacy': '✅ 귀하의 프로필은 기본적으로 비공개입니다 - 다른 사람이 귀하를 찾을 수 있도록 하려면 프로필 > 개인정보 보호에서 공개 표시를 활성화하세요',
                'help.tips.export': '✅ 헤더의 ⬇️ 버튼을 사용하여 전체 대화 내보내기 - 모든 이미지가 포함된 PDF 또는 HTML 선택',
                'help.support.title': '지원',
                'help.support.description': '문제나 질문이 있으면 시스템 관리자에게 문의하거나 사용 가능한 기술 문서를 검토하세요.',
                'help.about.title': '정보',
                'help.about.developer': '개발자:',
                'help.about.location': 'MDQ - 아르헨티나',
                'help.about.linkedin': 'LinkedIn 프로필 보기',
                'presence.title': '현재 상태',
                'presence.currentStatus': '현재 상태:',
                'presence.changeStatus': '상태 변경',
                'presence.status.online': '온라인',
                'presence.status.online.title': '온라인 - 모든 사람에게 표시',
                'presence.status.online.description': '온라인: 모든 연락처에 표시',
                'presence.status.idle': '유휴',
                'presence.status.idle.title': '유휴 - 일시적 부재를 나타냅니다',
                'presence.status.idle.description': '유휴: 일시적으로 이용할 수 없음을 나타냅니다',
                'presence.status.dnd': '방해 금지',
                'presence.status.dnd.title': '방해 금지 - 방해받고 싶지 않음을 나타냅니다',
                'presence.status.dnd.description': '방해 금지: 방해받고 싶지 않다는 시각적 표시',
                'presence.status.busy': '바쁨',
                'presence.status.busy.title': '바쁨 - 사용 불가',
                'presence.status.busy.description': '바쁨: 사용 불가',
                'presence.status.offline': '오프라인',
                'presence.status.offline.title': '연결 끊김 - 오프라인으로 표시',
                'presence.status.offline.description': '오프라인: 연결 끊김으로 표시',
                'presence.status.custom': '사용자 정의',
                'presence.status.custom.title': '사용자 정의 - 이모지가 있는 고유한 상태',
                'presence.status.custom.description': '사용자 정의: 이모지와 선택적 만료 시간이 있는 고유한 상태',
                'dashboard.title': '대시보드',
                'dashboard.planUsage': '플랜 사용량',
                'dashboard.filesSummary': '내 파일',
                'dashboard.promotions': '프로모션',
                'dashboard.sessions': '활성 세션',
                'dashboard.explore': '둘러보기',
                'dashboard.noSessions': '활성 세션이 없습니다',
                'dashboard.welcomeTitle': 'ArChat®에 오신 것을 환영합니다',
                'dashboard.welcomeSubtitle': '모든 언어로 대화하세요.',
                'dashboard.stepInvite': '1단계: 첫 연락처 초대',
                'dashboard.stepMessage': '2단계: 첫 메시지 보내기',
                'dashboard.inviteContact': '연락처 초대',
                'dashboard.exploreArChat': 'ArChat 둘러보기',
                'dashboard.promotionsTitle': '프로모션',
                'dashboard.promotionsText': '추천·보상 프로그램 요약.',
                'dashboard.viewPromotions': '프로모션 보기',
                'dashboard.usageTitle': '플랜 사용량',
                'dashboard.sessionsTitle': '활성 세션',
                'dashboard.sessionsEmpty': '활성 세션이 없습니다',
                'dashboard.filesTitle': '내 파일',
                'dashboard.viewFiles': '내 파일 보기',
                'dashboard.noBlocks': '활성 블록이 없습니다. 설정에서 최소 하나를 켜세요.',
                'dashboard.openSettings': '설정 열기',
                'dashboard.goToContacts': '연락처로 이동',
                'dashboard.filesVisible': '보이는 파일 수',
                'dashboard.filesSampleNote': '첫 페이지 기준(최대 500+).',
                'dashboard.loading': '데이터 로딩 중...',
                'dashboard.error.title': '오류',
                'dashboard.error.load': '사용 데이터를 로드할 수 없습니다',
                'dashboard.error.generic': '대시보드 로드 오류',
                'dashboard.error.no_data': '데이터를 로드할 수 없습니다',
                'dashboard.retry': '다시 시도',
                'dashboard.unlimited': '무제한',
                "dashboard.plan.free": "FREE",
                "dashboard.plan.pro": "PRO",
                "dashboard.plan.enterprise": "ENTERPRISE",
                'dashboard.card.contacts': '연락처',
                'dashboard.card.chars': '문자',
                'dashboard.card.chars_month': '이번 달 문자 수',
                'dashboard.card.storage': '저장소',
                'dashboard.card.devices': '활성 장치',
                'dashboard.upgrade.title': '더 많은 리소스가 필요하신가요?',
                'dashboard.upgrade.message': '플랜을 업그레이드하여 더 많은 연락처, 문자 수, 저장소 및 활성 장치를 이용하세요.',
                'dashboard.upgrade.button': '플랜 업그레이드',
                'upgrade.title': '플랜 업그레이드',
                'upgrade.close': '닫기',
                'upgrade.cancel': '취소',
                'upgrade.activate': 'PRO 플랜 활성화',
                'upgrade.activating': '활성화 중...',
                'upgrade.price.note': '',
                'upgrade.comparison.title': '플랜 비교',
                'upgrade.free.label': '무료 플랜',
                'upgrade.free.limits.contacts': '최대 2개의 연락처',
                'upgrade.free.limits.conversations': '최대 2개의 대화',
                'upgrade.free.limits.no_export': '데이터 내보내기 없음',
                'upgrade.free.limits.no_advanced': '고급 기능 없음',
                'upgrade.pro.label': 'Pro 플랜',
                'upgrade.pro.recommended': '권장',
                'upgrade.pro.benefits.contacts': '무제한 연락처',
                'upgrade.pro.benefits.contacts.desc': '제한 없이 필요한 모든 연락처 추가',
                'upgrade.pro.benefits.conversations': '무제한 대화',
                'upgrade.pro.benefits.conversations.desc': '필요한 모든 활성 대화 유지',
                'upgrade.pro.benefits.export': '대화 내보내기',
                'upgrade.pro.benefits.export.desc': '여러 형식 (PDF, TXT, JSON)으로 대화 내보내기',
                'upgrade.pro.benefits.notifications': '고급 알림',
                'upgrade.pro.benefits.notifications.desc': '맞춤 알림 및 고급 설정',
                'upgrade.pro.benefits.translation': '무제한 자동 번역',
                'upgrade.pro.benefits.translation.desc': '사용 제한 없이 메시지 번역',
                'upgrade.pro.benefits.files': '무제한 파일 전송',
                'upgrade.pro.benefits.files.desc': '제한 없이 모든 크기의 파일 공유',
                'upgrade.pro.benefits.themes': '맞춤 테마',
                'upgrade.pro.benefits.themes.desc': '모든 테마에 대한 액세스 및 고급 사용자 지정',
                'upgrade.pro.benefits.security': '고급 보안',
                'upgrade.pro.benefits.security.desc': '추가 보호 및 향상된 개인정보 보호 기능',
                'upgrade.pro.benefits.analytics': '통계 및 분석',
                'upgrade.pro.benefits.analytics.desc': '활동의 상세 통계에 액세스',
                'upgrade.pro.benefits.priority': '우선 지원',
                'upgrade.pro.benefits.priority.desc': '우선적인 관심과 빠른 응답',
                'upgrade.enterprise.label': 'Enterprise 플랜',
                'upgrade.enterprise.benefits.contacts': '무제한 연락처',
                'upgrade.enterprise.benefits.support': '24/7 우선 지원',
                'upgrade.enterprise.benefits.custom': '맞춤 솔루션',
                'upgrade.enterprise.benefits.advanced': '고급 엔터프라이즈 기능',
                'upgrade.enterprise.benefits.integration': '맞춤 통합',
                'upgrade.enterprise.benefits.dedicated': '전담 지원',
                'upgrade.success.title': 'PRO 플랜이 활성화되었습니다',
                'upgrade.success.message': '플랜이 PRO로 업데이트되었습니다. 모든 무제한 기능을 즐기세요.',
                'upgrade.error.title': 'PRO 활성화 오류',
                'upgrade.error.message': '플랜을 업데이트할 수 없습니다. 다시 시도해주세요.',
                'upgrade.error.generic': '예기치 않은 오류가 발생했습니다. 다시 시도해주세요.',
                'upgrade.benefits.contacts': '무제한 연락처',
                'upgrade.benefits.contacts.desc': '제한 없이 필요한 모든 연락처 추가',
                'upgrade.benefits.conversations': '무제한 대화',
                'upgrade.benefits.conversations.desc': '필요한 모든 활성 대화 유지',
                'upgrade.benefits.export': '대화 내보내기',
                'upgrade.benefits.export.desc': '여러 형식 (PDF, TXT, JSON)으로 대화 내보내기',
                'upgrade.benefits.notifications': '고급 알림',
                'upgrade.benefits.notifications.desc': '맞춤 알림 및 고급 설정',
                'upgrade.benefits.translation': '무제한 자동 번역',
                'upgrade.benefits.translation.desc': '사용 제한 없이 메시지 번역',
                'upgrade.benefits.files': '무제한 파일 전송',
                'upgrade.benefits.files.desc': '제한 없이 모든 크기의 파일 공유',
                'upgrade.benefits.themes': '맞춤 테마',
                'upgrade.benefits.themes.desc': '모든 테마에 대한 액세스 및 고급 사용자 지정',
                'upgrade.benefits.security': '고급 보안',
                'upgrade.benefits.security.desc': '추가 보호 및 향상된 개인정보 보호 기능',
                'upgrade.benefits.analytics': '통계 및 분석',
                'upgrade.benefits.analytics.desc': '활동의 상세 통계에 액세스',
                'upgrade.benefits.priority': '우선 지원',
                'upgrade.benefits.priority.desc': '우선적인 관심과 빠른 응답',
                'upgrade.limits.contacts': '최대 2개의 연락처',
                'upgrade.limits.conversations': '최대 2개의 대화',
                'upgrade.limits.no_export': '데이터 내보내기 없음',
                'upgrade.limits.no_advanced': '고급 기능 없음',
                // API Error Messages
                'api.error.image_processing_not_available': '서버에서 이미지 처리를 사용할 수 없습니다',
                'api.error.image_functions_not_available': '이미지 처리 기능을 사용할 수 없습니다',
                'api.error.method_not_allowed': '허용되지 않은 메서드',
                'api.error.user_not_identified': '사용자가 식별되지 않았습니다',
                'api.error.upload_file_too_large_php': '파일이 PHP에서 허용하는 최대 크기를 초과했습니다',
                'api.error.upload_file_too_large_form': '파일이 양식에서 허용하는 최대 크기를 초과했습니다',
                'api.error.upload_file_partial': '파일이 부분적으로 업로드되었습니다',
                'api.error.upload_no_file': '파일이 업로드되지 않았습니다',
                'api.error.upload_no_temp_dir': '임시 디렉토리가 없습니다',
                'api.error.upload_cant_write': '디스크에 파일 쓰기 오류',
                'api.error.upload_extension_stopped': 'PHP 확장이 업로드를 중지했습니다',
                'api.error.upload_generic': '파일 업로드 오류',
                'api.error.file_type_not_allowed': '허용되지 않은 파일 유형. 이미지만 허용됩니다 (JPEG, PNG, GIF, WEBP)',
                'api.error.file_too_large': '파일이 너무 큽니다 (최대 10MB)',
                'api.error.storage_limit_exceeded': '저장소 제한을 초과했습니다. 더 많은 파일을 업로드하려면 플랜을 업그레이드하세요.',
                'api.error.user_not_found': '사용자를 찾을 수 없거나 비활성 상태입니다',
                'api.error.image_directory_access': '이미지 디렉토리 액세스 오류',
                'api.error.file_extension_not_allowed': '허용되지 않은 파일 확장자',
                'api.error.temp_file_save': '임시 파일 저장 오류',
                'api.error.image_processing': '이미지 처리 오류',
                'api.error.database_update': '데이터베이스 업데이트 오류',
                'api.error.internal_server_error': '내부 서버 오류',
                'api.error.internal_server_error_debug': '내부 서버 오류',
                'api.error.user_id_required': '사용자 ID가 필요합니다',
                'api.error.profile_not_found': '프로필을 찾을 수 없습니다',
                'api.error.profile_load_failed': '프로필 로드 오류',
                'api.error.invalid_data': '잘못된 데이터',
                'api.error.validation_errors': '유효성 검사 오류',
                'api.error.profile_update_failed': '프로필을 업데이트할 수 없습니다',
                'api.error.profile_update_error': '프로필 업데이트 오류',
                // API Success Messages
                'api.success.photo_updated': '사진이 업데이트되었습니다',
                'api.success.profile_loaded': '프로필이 성공적으로 로드되었습니다',
                'api.success.profile_updated': '프로필이 성공적으로 업데이트되었습니다',
                // Error Messages - Device Limits
                'errors.deviceLimit.title': '기기 제한에 도달했습니다',
                'errors.deviceLimit.solution': '계속하려면 다른 기기에서 로그아웃하거나 플랜을 업그레이드하세요.',
                // Error Messages - Network
                'errors.network.title': '연결 오류',
                'errors.network.message': '서버에 연결할 수 없습니다. 인터넷 연결을 확인하세요.',
                // Error Messages - Server
                'errors.server.invalidResponse.title': '서버 오류',
                'errors.server.invalidResponse.message': '서버가 잘못된 응답을 반환했습니다. 다시 시도하세요.',
                // Error Messages - Generic
                'errors.generic.title': '오류',
                'errors.generic.message': '오류가 발생했습니다. 다시 시도하세요.',
                'errors.generic.403.title': '액세스 오류',
                'errors.generic.403.message': '이 작업을 수행할 권한이 없습니다.',
                'errors.saas_max_users': '플랜 사용자 한도에 도달했습니다 ({current}/{limit}).',
                'errors.tenant_frozen': '테넌트가 일시적으로 차단되었습니다.',
                'errors.auth_invalid_credentials': '사용자 이름 또는 비밀번호가 올바르지 않습니다.',
                'errors.accountInactive.title': '계정이 비활성화되었습니다. 이메일을 입력하여 재활성화하세요.',
                'errors.accountInactive.activate': '지금 활성화',
                'errors.accountInactive.accept': '수락',
                'errors.accountInactive.success': '계정이 재활성화되었습니다. 로그인할 수 있습니다.',
                'errors.accountInactive.fail': '계정을 재활성화할 수 없습니다. 다시 시도하세요.',
                'errors.accountInactive.completeSuccess': '이메일로 계정이 활성화되었습니다. 로그인할 수 있습니다.',
                'errors.accountInactive.completeFail': '활성화를 완료할 수 없습니다. 이메일을 확인하고 다시 시도하세요.',
                // Plan Errors - Device Limit
                'plan.errors.deviceLimit.title': '플랜 제한에 도달했습니다',
                'plan.errors.deviceLimit.message': '현재 플랜에는 동시에 연결할 수 있는 기기 수에 제한이 있습니다.',
                'plan.errors.deviceLimit.solution': '계속하려면 다른 기기에서 로그아웃하거나 플랜을 PRO로 업그레이드하세요.',
                // Plan Errors - Contacts Limit
                'plan.errors.contactsLimit.title': '연락처 제한에 도달했습니다',
                'plan.errors.contactsLimit.message': '현재 플랜에는 보유할 수 있는 연락처 수에 제한이 있습니다.',
                'plan.errors.contactsLimit.solution': '더 많은 연락처를 추가하려면 플랜을 PRO로 업그레이드하세요.',
                // Plan Errors - Invitations Limit
                'plan.errors.invitationsLimit.title': '초대 제한에 도달했습니다',
                'plan.errors.invitationsLimit.message': '현재 플랜에는 하루에 보낼 수 있는 초대 수에 제한이 있습니다.',
                'plan.errors.invitationsLimit.solution': '더 많은 초대를 보내려면 플랜을 PRO로 업그레이드하세요.',
                // Plan Errors - Messages Limit
                'plan.errors.messagesLimit.title': '메시지 제한에 도달했습니다',
                'plan.errors.messagesLimit.message': '현재 플랜에는 하루에 보낼 수 있는 메시지 수에 제한이 있습니다.',
                'plan.errors.messagesLimit.solution': '더 많은 메시지를 보내려면 플랜을 PRO로 업그레이드하세요.',
                // Plan Errors - Storage Limit
                'plan.errors.storageLimit.title': '저장소 제한에 도달했습니다',
                'plan.errors.storageLimit.message': '현재 플랜에는 사용 가능한 저장소 양에 제한이 있습니다.',
                'plan.errors.storageLimit.solution': '더 많은 저장소를 얻으려면 플랜을 PRO로 업그레이드하세요.',
                // Plan Errors - Upgrade Required
                'plan.errors.upgradeRequired.title': '플랜 업그레이드 필요',
                'plan.errors.upgradeRequired.message': '이 기능은 현재 플랜보다 높은 플랜이 필요합니다.',
                'plan.errors.upgradeRequired.solution': '이 기능에 액세스하려면 플랜을 PRO로 업그레이드하세요.',
                "appearance.theme.system": "체계",
                "appearance.theme.corporate": "기업",
                "theme.system": "체계",
                "theme.corporate": "기업",
                'founder.title': 'FOUNDATION (파운더)',
                'founder.subtitle': '평생 가격으로 프로젝트를 처음부터 지원합니다.',
                'founder.whatIs': '선착순 150명이 FOUNDATION 플랜을 할인 평생 가격으로 이용할 수 있습니다.',
                'founder.howItWorks': '파운더 등급은 위치(1~150)에 따라 결정됩니다.',
                'founder.benefitsTitle': '혜택',
                'founder.benefitPrice': '월 $15 (Founder)',
                'founder.benefitFeatures': 'PRO 플랜의 모든 기능을 포함합니다.',
                'founder.limit': '파운더 자리는 150개뿐입니다.',
                'founder.cancelRule': '해지 중에는 파운더 자격을 잃습니다.',
                'founder.rejoinRule': '자리가 다시 생기면 재개 시 자동으로 파운더로 복귀할 수 있습니다.',
                'founder.tiers.title': '파운더 등급',
                'founder.tiers.legendary.name': 'LEGENDARY 파운더',
                'founder.tiers.legendary.range': '위치 1–25',
                'founder.tiers.legendary.desc': '프로젝트를 가장 먼저 지원한 분. 최고의 역사적 우선순위.',
                'founder.tiers.early.name': 'EARLY 파운더',
                'founder.tiers.early.range': '위치 26–75',
                'founder.tiers.early.desc': '얼리 서포터, 특별 인정.',
                'founder.tiers.founder.name': '파운더',
                'founder.tiers.founder.range': '위치 76–150',
                'founder.tiers.founder.desc': '150석 내 파운더 자리.',
                'founder.whatIsLink': '파운더란?',
                'founder.viewTiers': '파운더 등급 보기',
                'founder.modalClose': '닫기',
                'founder.activeCountLabel': '참여한 파운더',
                'founder.urgency.lastSlots': '마지막 파운더 슬롯',
                "founder.positionLabel": "창립자 #{position} / {limit}",
                'founder.leaderboard.title': '탑 파운더',
                "login.email.placeholder": "Ingresa tu email para confirmar tu cuenta",
                "login.email.help": "확인 링크가 귀하의 이메일로 전송됩니다",
                "auth.user_not_found": "사용자를 찾을 수 없습니다.",
                "auth.user_inactive": "귀하의 계정이 비활성화되었습니다. 관리자에게 문의하세요.",
                "auth.tenant_mismatch": "귀하의 계정은 이 환경에 속하지 않습니다. 관리자에게 문의하세요.",
                "auth.captcha_required": "보안 확인(CAPTCHA)을 완료해야 합니다.",
                "mail.send_failed": "복구 이메일을 보낼 수 없습니다. SMTP 설정을 확인하거나 나중에 다시 시도하세요.",
                "auth.resend_activation": "활성화 이메일 다시 보내기",
                "register.creatingAccount": "계정을 만드는 중…",
                "common.edit": "편집하다",
                "common.on": "활성화됨",
                "common.off": "장애가 있는",
                "common.refresh": "업데이트",
                "system.processing": "처리 중...",
                "captcha.incorrect": "보안 문자 답변이 잘못되었습니다.",
                "captcha.placeholder": "답을 쓰세요",
                "captcha.questionFormat": "{a} + {b}는 무엇입니까?",
                'menu.admin': '관리',
                'navbar.status': '상태',
                "navbar.users": "사용자",
                'navbar.no_blocked_users': '차단된 사용자가 없습니다',
                'navbar.blocked_users_title': '차단된 사용자',
                'contacts.blocked_users_title': '차단된 사용자',
                'contacts.country_label': '국가',
                'contacts.not_reported': '미입력',
                "navbar.user_fallback": "사용자 {id}",
                "navbar.open_guide": "가이드",
                "help.how_archat_works": "ArChat® 작동 방식",
                "help.registration": "기록",
                "help.private_invitations": "비공개 초대",
                "help.messaging": "메시징",
                "help.security": "보안",
                "invitation.quick_button": "연락처 초대",
                "onboarding.title": "ArChat®에 오신 것을 환영합니다",
                "onboarding.subtitle": "어떤 언어로든 누구와도 소통할 수 있습니다.",
                "onboarding.step1.label": "1단계",
                "onboarding.step1.text": "첫 번째 연락처 초대",
                "onboarding.step2.label": "2단계",
                "onboarding.step2.text": "첫 번째 메시지 보내기",
                "onboarding.actions.invite": "연락처 초대",
                "onboarding.actions.explore": "ArChat® 살펴보기",
                'suggestions.sendSuccess': '제안이 성공적으로 전송되었습니다.',
                'suggestions.sendError': '제안을 전송할 수 없습니다. 다시 시도해 주세요.',
                'suggestions.sent': '제안이 성공적으로 전송되었습니다.',
                'errors.suggestionSend': '제안을 전송할 수 없습니다. 다시 시도해 주세요.',
                'app.install': 'ArChat 설치',
                'menu.open': '메뉴',
                "contacts.controls.hide_non_favorites": "즐겨찾지 않는 연락처 숨기기",
                "contacts.controls.show_all": "모든 연락처 표시",
                "common.navigation": "항해",
                "common.favorite": "가장 좋아하는",
                "common.block": "차단하다",
                "common.user": "사용자",
                "message.new": "새 메시지",
                "message.edit": "메시지 편집",
                "message.edit.save": "수정사항 저장",
                "message.edit.cancel": "편집 취소",
                'message.translating': '번역 중...',
                'message.translation_failed': '번역할 수 없습니다',
                'message.not_translated': '원문',
                'message.retry_send': '다시 시도',
                'message.retrying': '다시 시도 중...',
                "message.delete": "메시지 삭제",
                'message.deleted_placeholder': '메시지가 삭제됨',
                "message.edited": "편집됨",
                "message.edited_at": "편집 날짜",
                'message.delete_for_me.tooltip': '나만 삭제',
                'message.delete_for_me.aria': '이 메시지를 나에게만 삭제',
                'message.delete_for_me.confirm_title': '메시지 삭제',
                'message.delete_for_me.confirm_message': '이 메시지는 내 화면에서만 삭제됩니다.',
                'message.delete_for_everyone.tooltip': '모두에게서 삭제',
                'message.delete_for_everyone.aria': '이 메시지를 모든 참여자에게서 삭제',
                'message.delete_for_everyone.confirm_title': '모두에게서 메시지 삭제',
                'message.delete_for_everyone.confirm_message': '이 메시지는 나와 상대방 모두에게서 삭제됩니다.',
                'message.delete_for_everyone.window_expired': '삭제 가능 시간이 만료되었습니다',
                "message.translation.show": "원문 및 번역 보기",
                "message.translation.hide": "번역 숨기기",
                "emoji.search": "이모티콘 검색",
                "emoji.close": "선택기 닫기",
                "captcha.refresh": "보안문자 재생성",
                'presence.unavailable': 'Statusreul sayonghal su eopseumnida',
                'presence.maintenance': 'Seobeo jeongbi jung',
                "home.access_nav": "애플리케이션에 대한 액세스",
                "common.requiredFields": "필수 필드를 모두 작성하세요.",
                "bio.view": "전기 보기",
                "profile.nick.readonly": "사용자 이름은 수정할 수 없습니다.",
                "profile.nick.readonly.help": "사용자 이름은 고유하며 수정할 수 없습니다.",
                "profile.email.readonly": "이메일은 수정할 수 없습니다",
                "profile.email.readonly.help": "이메일은 고유하며 수정할 수 없습니다.",
                "profile.invitations.title": "초대장",
                "profile.invitations.validated": "검증된 초대장",
                "profile.invitations.nextBadge": "다음 업적",
                "profile.invitations.progress": "진전",
                "profile.invitations.achievement": "성취",
                "profile.invitations.topInviterAchieved": "최대 초대자 도달",
                "profile.invitations.badges.networkBuilder": "네트워크 빌더",
                "profile.invitations.badges.topInviter": "최대 초대자",
                "profile.invitations.achievement.networkBuilderMessage": "ArChat에 20명의 사용자를 초대하셨습니다.",
                "profile.invitations.achievement.topInviterMessage": "ArChat에 50명의 사용자를 초대하셨습니다.",
                "profile.plan.loading_info": "계획 정보 로드 중...",
                "profile.plan.valid_until": "유효기간:",
                "profile.plan.active_since": "활성 날짜:",
                "profile.plan.active_badge": "✓ 활성",
                "profile.manage_plan": "계획 관리",
                "plan.current_plan": "현재 계획",
                "plan.current": "Actual",
                'plan.footer_prefix': '플랜:',
                "plan.upgrade_to_pro": "PRO로 업그레이드",
                "plan.upgrade_to_foundation": "파운데이션으로 업그레이드",
                "plan.payment_coming": "Paddle을 이용한 결제도 곧 가능해집니다. 여기에서 계획을 변경할 수 있습니다.",
                "plan.payment_coming_title": "곧",
                "plan.foundation_full": "FOUNDATION 할당량이 가득 찼습니다(창립자 150명). PRO를 선택하시면 됩니다.",
                "plan.sold_out": "탈진한",
                "plan.founder_spots_remaining": "{count}개 장소만 이용 가능",
                "plan.founders_occupied": "바쁜 창업자들",
                "plan.upgrade_not_allowed": "무료 요금제를 사용하는 사용자만 업그레이드를 요청할 수 있습니다.",
                "plan.free_contacts": "Hasta 2 contactos",
                "plan.free_no_files": "Sin archivos",
                "plan.free_retention": "Historial 30 días",
                "plan.pro_files": "Archivos hasta 50MB",
                "plan.pro_export": "Exportación",
                "plan.founder_support": "Prioridad soporte",
                "plan.founder_badge": "Badge fundador",
                "billing.usage.contacts": "콘택트 렌즈",
                "billing.usage.chars_month": "월별 문자",
                "billing.usage.storage": "사용된 저장공간",
                "billing.usage.devices": "연결된 장치",
                "billing.loading": "충전 중...",
                'billing.subscription.section_title': '구독 및 결제',
                'billing.subscription.provider_note': '제공자',
                'billing.subscription.paddle_active': 'Paddle(앱에서 활성 플랜)',
                'billing.subscription.mp_action_ok': '요청이 기록되었습니다. 결제 창이 열리지 않으면 연결을 확인하거나 다시 시도하세요.',
                'billing.paddle.manage_subscription_button': '구독 관리',
                'billing.paddle.portal_confirm_title': '결제 포털',
                'billing.paddle.portal_confirm': '안전한 Paddle 포털이 열려 결제 수단, 청구서를 업데이트하거나 구독을 취소할 수 있습니다. 계속할까요?',
                'billing.paddle.portal_opened_hint': 'Paddle 포털이 새 탭에서 열렸습니다. 플랜이 갱신되지 않으면 프로필을 새로고침하세요.',
                'billing.paddle.portal_error': 'Paddle 포털을 열 수 없습니다. 나중에 다시 시도하거나 지원팀에 문의하세요.',
                'billing.paddle.no_link_error': '계정에 Paddle 구독 연결이 아직 없습니다. 방금 결제했다면 웹훅을 기다리거나 지원팀에 문의하세요.',
                'billing.paddle.api_not_configured': '서버에 Paddle API 설정(PADDLE_API_KEY)이 없습니다. 관리자가 설정해야 합니다.',
                "billing.descriptions.contacts": "귀하의 계정에 저장된 총 연락처",
                "billing.descriptions.storage": "파일 및 미디어에 사용되는 저장소",
                "billing.descriptions.chars_month": "이번 달에 번역된 캐릭터",
                "billing.descriptions.devices": "활성 연결된 장치",
                'billing.paddle.return_title': '결제가 접수되었습니다',
                'billing.paddle.return_body': '결제를 완료했다면 Paddle 확인 후 곧 플랜이 업데이트됩니다. 홈으로 돌아갈 수 있습니다.',
                'billing.paddle.verifying': '플랜 확인 중…',
                'billing.paddle.not_logged_in': '로그인하여 플랜 상태를 확인하세요.',
                'billing.paddle.plan_updated': '플랜이 업데이트되었습니다: {plan}',
                'billing.paddle.plan_current': '현재 플랜: {plan}',
                'billing.paddle.plan_current_founder': '이제 Founder입니다 — {plan}',
                'billing.paddle.still_free_hint': '잠시 후에도 FREE라면 웹훅이 지연됐을 수 있습니다. 백엔드 로그를 확인하거나 페이지를 새로고침하세요.',
                'billing.paddle.pro_extra_hint': '홈으로 돌아가 플랜을 이용하세요.',
                "attachment.audioNotSupported": "ArChat®에서는 오디오 메시지가 지원되지 않습니다. 서면으로 메시지를 보내주세요.",
                "message.audioDeprecated.title": "음성 메시지는 지원되지 않습니다.",
                "message.audioDeprecated.message": "이 음성 메시지는 ArChat®에서 더 이상 지원되지 않습니다. 서면으로 메시지를 보내주세요.",
                "profile.photo.select": "사진 선택",
                "profile.photo.select.gallery": "갤러리에서 선택",
                "avatar.errors.too_large": "이미지가 너무 큽니다. 최대 크기: 2MB.",
                "avatar.preview.title": "아바타 미리보기",
                "profile.avatar.error_title": "아바타를 업데이트할 수 없습니다.",
                "profile.avatar.error.title": "아바타를 업데이트할 수 없습니다.",
                "profile.avatar.error.size": "이미지가 허용된 크기를 초과했습니다. 최대값은 2MB입니다.",
                "profile.avatar.tooLarge.title": "이미지가 너무 큼",
                "profile.avatar.tooLarge.message": "사진이 허용된 크기를 초과했습니다. 최대값은 2MB입니다.",
                "profile.avatar.uploadError.title": "아바타를 업데이트할 수 없습니다.",
                "profile.avatar.uploadError.message": "이미지를 업로드하는 중에 문제가 발생했습니다. 다시 시도해 보세요.",
                "profile.saveSuccess.title": "업데이트된 프로필",
                "profile.saveSuccess.message": "변경사항이 성공적으로 저장되었습니다.",
                "profile.avatar.file_too_large": "이미지가 허용되는 최대 크기(2MB)를 초과했습니다.",
                "profile.avatar.file_too_large_hint": "더 밝은 이미지를 선택하거나 크기를 줄이고 다시 시도하세요.",
                "profile.photo.take.front": "전면 카메라",
                "profile.photo.take.back": "후면 카메라",
                "profile.photo.take.webcam": "웹캠",
                "profile.photo.camera.front": "전면 카메라",
                "profile.photo.camera.back": "후면 카메라",
                "profile.photo.camera.web": "웹캠",
                "profile.photo.close": "닫다",
                "profile.photo.capture": "포착",
                "block.toggle_error": "잠그거나 잠금 해제할 수 없습니다.",
                "contact.favorite.add": "즐겨찾기에 추가",
                "contact.favorite.remove": "즐겨찾기에서 제거",
                "contact.block.block": "차단하다",
                'contact.block.unblock': '차단 해제',
                "conversation.notFound": "대화를 찾을 수 없습니다.",
                "help.howWorks.title": "👥 ArChat® 작동 방식(실제 흐름)",
                "help.howWorks.step1.title": "1️⃣ 등록",
                "help.howWorks.step1.point1": "닉네임과 비밀번호로 로그인하세요.",
                "help.howWorks.step1.point2": "계정이 없으면 자동으로 생성됩니다.",
                "help.howWorks.step1.point3": "귀하는 귀하의 언어로 된 이용 약관에 동의합니다.",
                "help.howWorks.step1.point4": "이메일로 계정을 확인합니다.",
                "help.howWorks.step2.title": "2️⃣ 비공개 초대",
                "help.howWorks.step2.point1": "프로필에서 이메일로 연락처를 초대하세요.",
                "help.howWorks.step2.point2": "시작하기 전에 언어와 대화 모드를 정의하세요.",
                "help.howWorks.step2.point3": "연락처가 비공개 초대를 받습니다.",
                "help.howWorks.step2.point4": "보류 중, 등록됨, 채팅 준비 완료 상태인지 확인할 수 있습니다.",
                "help.howWorks.step2.point5": "연락처를 찾는 것이 아니라 초대하는 것입니다.",
                "help.howWorks.step2.point6": "연락처를 찾는 것이 아니라 초대하는 것입니다.",
                "help.howWorks.step3.title": "3️⃣ 연락처 및 대화",
                "help.howWorks.step3.point1": "다음과 같은 경우 연락처가 자동으로 표시됩니다.",
                "help.howWorks.step3.point2": "초대를 수락하다",
                "help.howWorks.step3.point3": "아니면 대화가 있어요",
                "help.howWorks.step3.point4": "할 수 있다:",
                "help.howWorks.step3.point5": "즐겨찾기로 표시 ⭐",
                "help.howWorks.step3.point6": "사용자 정의 별칭 할당",
                "help.howWorks.step3.point7": "비공개 메모 추가",
                "help.howWorks.step3.point8": "차단하거나 관리하세요",
                "help.howWorks.step3.point9": "동의 없이는 공개 의제나 눈에 보이는 사용자가 없습니다.",
                "help.howWorks.step4.title": "4️⃣ 번역을 통한 메시지",
                "help.howWorks.step4.point1": "항상 귀하의 언어로 작성하십시오.",
                "help.howWorks.step4.point2": "시스템이 자동으로 메시지를 번역합니다.",
                "help.howWorks.step4.point3": "수신자는 자신의 언어로 이를 받습니다.",
                "help.howWorks.step4.point4": "번역이 적용된 것을 볼 수 있습니다.",
                "help.howWorks.step4.point5": "번역이 실패하면 자동으로 재시도됩니다.",
                "help.howWorks.step4.point6": "ArChat®은 속도뿐만 아니라 명확성과 의미를 우선시합니다.",
                "help.privacy.title": "🔒 개인 정보 보호 및 제어",
                "help.privacy.point1": "귀하의 프로필은 기본적으로 비공개입니다.",
                "help.privacy.point2": "귀하가 초대한 사람만 귀하를 보거나 편지를 보낼 수 있습니다.",
                "help.privacy.point3": "공개 가시성은 선택 사항이며 기본적으로 비활성화되어 있습니다.",
                "help.privacy.point4": "다음을 통한 능동 안전:",
                "help.privacy.point5": "보안 문자",
                "help.privacy.point6": "속도 제한",
                "help.privacy.point7": "지문",
                "help.privacy.point8": "이메일 확인",
                "help.privacy.point9": "귀하의 대화는 공개되지 않거나 색인화되지 않습니다.",
                "help.files.title": "📎 파일 및 내보내기",
                "help.files.point1": "이미지, 비디오, PDF 문서를 첨부하세요.",
                "help.files.point2": "전면 카메라, 후면 카메라 또는 웹캠으로 사진을 캡처하세요.",
                "help.files.point3": "이미지는 자동으로 압축됩니다.",
                "help.files.point4": "보내기 전에 미리 보세요.",
                "help.files.point5": "로딩 중 진행률 표시줄.",
                "help.files.point6": "전체 대화를 다음으로 내보내기:",
                "help.files.point7": "PDF",
                "help.files.point8": "HTML",
                "help.files.point9": "메시지, 이미지, 파일이 포함됩니다.",
                "help.files.point10": "귀하의 데이터는 귀하의 것입니다.",
                "help.experience.title": "🎨 사용자 경험",
                "help.experience.point1": "이모티콘을 사용한 현재 상태 및 사용자 정의 상태.",
                "help.experience.point2": "통합 OpenMoji 이모티콘.",
                "help.experience.point3": "표시기를 읽고 씁니다.",
                "help.experience.point4": "데스크탑과 동일하게 최적화된 모바일 보기.",
                "help.experience.point5": "설치 가능한 PWA 애플리케이션.",
                "help.experience.point6": "두 가지 테마: 아르헨티나(연한 파란색/흰색/금색) 및 Oscuro(짙은 보라색).",
                "help.experience.point7": "청량음료 없이 프로필 편집.",
                "help.experience.point8": "자동 시간대를 갖춘 국가 선택기.",
                "help.experience.point9": "즐겨찾기, 검색, 필터를 통해 빠르게 액세스하세요.",
                "help.languages.title": "🌍 언어",
                "help.languages.point1": "{count}개 언어를 지원합니다.",
                "help.languages.point2": "플래그가 있는 시각적 선택기입니다.",
                "help.languages.point3": "선택한 언어에 맞게 인터페이스, T&C 및 이메일이 조정됩니다.",
                "help.languages.point4": "사용자 간 양방향 자동 번역.",
                "help.tipsNew.title": "💡 ArChat® 활용 팁",
                "help.tipsNew.point1": "꼭 소통하고 싶은 사람들만 초대하세요.",
                "help.tipsNew.point2": "별칭과 개인 메모를 사용하여 연락처를 정리하세요.",
                "help.tipsNew.point3": "빠른 액세스를 위해 즐겨찾기를 표시하세요.",
                "help.tipsNew.point4": "중요한 메시지를 보내기 전에 번역을 확인하세요.",
                "help.tipsNew.point5": "백업이나 업무를 위해 관련 대화를 내보냅니다.",
                "help.tipsNew.point6": "서면의 명확성이 핵심인 경우 ArChat®을 사용하십시오.",
                "help.whySubscribe.title": "🚀 ArChat®을 구독하는 이유",
                "help.whySubscribe.point1": "ArChat®은 누구와도 채팅하도록 설계되지 않았습니다.",
                "help.whySubscribe.point2": "하지만 중요한 사람들과 더 잘 소통하기 위해서입니다.",
                "help.whySubscribe.point3": "필요한 경우:",
                "help.whySubscribe.point4": "언어 간 명확성",
                "help.whySubscribe.point5": "진정한 프라이버시",
                "help.whySubscribe.point6": "접촉 제어",
                "help.whySubscribe.point7": "대화 내보내기",
                "help.whySubscribe.point8": "전문적이고 소음 없는 경험",
                "help.whySubscribe.point9": "ArChat®은 이를 위해 설계되었습니다.",
                "help.message_time_context.title": "메시지의 시간적 맥락",
                "help.message_time_context.description": "각 메시지는 전송 당시 발신자의 현지 시간, 시간대 및 국가를 저장할 수 있습니다. 이렇게 하면 다른 사용자가 보낸 장소와 시간을 확인할 수 있습니다.",
                "help.message_time_context.point1": "무료 요금제에서는 해당 시간대(수신자)의 시간만 표시됩니다.",
                "help.message_time_context.point2": "PRO 요금제에는 발급자의 현지 시간, 국가 및 시간대도 표시됩니다.",
                "help.message_time_context.point3": "컨텍스트는 각 메시지에 기록으로 저장됩니다.",
                "help.message_time_context.point4": "고급 계획에서는 고급 감사 기능을 사용할 수 있습니다.",
                "help.tips.writing": "✅ 명확한 메시지 작성: ArChat®은 문맥과 명확성을 유지하면서 작성된 텍스트의 의미를 번역합니다.",
                'presence.custom.title': 'Sayongja jeong-ui sangtae',
                'presence.custom.status': 'Sayongja jeong-ui sangtae',
                'presence.custom.placeholder': 'Ye: Keopi masineun jung ☕',
                'presence.custom.emoji': 'Emoji (seontaek)',
                'presence.custom.emojiHelp': 'Emoji-reul seontaekhageona ipryeokhaseyo',
                'presence.custom.temporary': 'Imsi sangtae (jadongeuro manryo)',
                'presence.custom.expiration': 'Manryo ilsi',
                'presence.custom.expirationHelp': 'Manryodoemyeon sangtaega "Online"euro doragam',
                'presence.custom.suggestions': 'Chucheon',
                'presence.custom.preview': 'Miri bogi',
                'presence.custom.save': 'Sangtae jeojang',
                'presence.custom.required': 'Sayongja jeong-ui sangtaeneun pilsuimnida',
                'presence.custom.maxLength': 'Choedae 64ja',
                'presence.custom.expirationRequired': 'Manryo ilsireul seontaekhaeya hamnida',
                'presence.custom.expirationFuture': 'Manryo ilsineun miraeyeoya hamnida',
                'presence.custom.selectEmoji': 'Emoji seontaek',
                "invitation.success.title": "초대장이 전송되었습니다",
                "invitation.success.message": "초대장이 성공적으로 전송되었습니다.\\n\\n연락처는 초대를 수락할 수 있는 링크가 포함된 이메일을 받게 됩니다. 수락하면 그와 채팅을 시작할 수 있습니다.",
                "invitation.top.title": "최고의 네트워크 빌더",
                "invitation.top.invitesSuffix": "초대장",
                "invitation.ranking.position": "위치",
                "invitation.ranking.user": "사용자",
                "invitation.ranking.validatedInvites": "검증된 초대장",
                "invitation.ranking.empty": "표시할 확인된 초대장이 없습니다.",
                "invitation.ranking.loading": "순위 로드 중...",
                "invitation.ranking.loadError": "순위를 로드할 수 없습니다.",
                "invitations.waitBeforeResend": "아직 초대장을 다시 보낼 수 없습니다. 게스트 사용자에게 스팸을 보내는 것을 방지하려면 각 전송 사이에 10분을 기다려야 합니다.",
                "invitations.captchaQuestion": "%1 + %2는 얼마입니까?",
                "invitations.resendSuccess": "초대장이 성공적으로 전달되었습니다.",
                "invitations.dailyLimit": "오늘 허용된 최대 재제출 횟수에 도달했습니다.",
                "invitations.invalidEmail": "메일 서버에서 이 주소가 유효하지 않다고 보고했습니다.",
                "achievement.unlocked": "업적 잠금 해제",
                "achievement.continue": "계속하다",
                'dashboard.not_available': '사용할 수 없음',
                "plan.errors.chatsLimit.title": "대화 한도에 도달했습니다.",
                "plan.errors.chatsLimit.message": "현재 계획에는 가질 수 있는 대화 수가 제한되어 있습니다.",
                "plan.errors.chatsLimit.solution": "더 많은 대화를 창출하려면 플랜을 PRO로 업그레이드하세요.",
                "errors.generic": "예상치 못한 오류가 발생했습니다. 다시 시도해 보세요.",
                "errors.modal.title": "실수",
                "errors.modal.copyDetails": "세부정보 복사",
                "errors.modal.close": "닫다",
                "errors.modal.reportSupport": "지원팀에 신고",
                "errors.avatarTooLarge": "이미지가 허용된 크기인 2MB를 초과했습니다.",
                "errors.avatarTooLarge.title": "이미지가 너무 큼",
                "errors.avatarTooLarge.message": "이미지가 허용된 크기인 2MB를 초과했습니다.",
                "errors.invalidImageType": "선택한 파일은 유효한 이미지가 아닙니다.",
                "errors.invalidImageType.title": "잘못된 파일",
                "errors.invalidImageType.message": "선택한 파일은 유효한 이미지가 아닙니다.",
                "errors.uploadFailed": "이미지를 업로드할 수 없습니다. 다시 시도해 보세요.",
                "errors.uploadFailed.title": "업로드하는 중 오류가 발생했습니다.",
                "errors.uploadFailed.message": "이미지를 업로드할 수 없습니다. 다시 시도해 보세요.",
                "errors.conversationCreate": "대화를 만드는 중에 오류가 발생했습니다. 다시 시도해 주세요.",
                "errors.conversationInvalidId": "잘못된 대화 ID입니다.",
                "errors.conversationOpen": "대화를 여는 중에 오류가 발생했습니다. 다시 시도해 주세요.",
                "errors.favoriteUpdate": "즐겨찾기를 업데이트하지 못했습니다.",
                "errors.blockUpdate": "잠금을 업데이트할 수 없습니다.",
                "errors.messageEdit": "메시지를 편집하는 중에 오류가 발생했습니다.",
                "errors.foundation_sold_out": "창업자 자리는 매진되었습니다.",
                "errors.unexpected_error": "예상치 못한 오류가 발생했습니다. 다시 시도해 보세요.",
                "errors.userInactive.title": "비활성화된 계정",
                "errors.tenantMismatch.title": "테넌트 오류",
                'auth.tagline': '언어와 상관없이 이해받는 힘',
                'auth.sign_in': '로그인',
                'auth.create_account': '계정 만들기',
                'ui.search_contact': '연락처 검색...',
                'ui.language': '언어',
                'profile.my_profile': '내 프로필',
                'profile.status': '상태',
                'profile.invite_email': '이메일로 연락처 초대',
                'profile.sent_invitations': '보낸 초대',
                "profile.users": "사용자",
                'profile.settings': '설정',
                'profile.appearance': '모양',
                'profile.logout': '로그아웃',
                'contacts.mode': '모드',
                'contacts.sent': '전송됨',
                'contacts.actions': '작업',
                'contacts.pending': '대기 중',
                'contacts.available': '사용 가능',
                'contacts.invited_registered': '초대됨 - 등록됨',
                'table.email': '이메일',
                'table.language': '언어',
                'table.mode': '모드',
                'table.status': '상태',
                'table.sent': '전송됨',
                'table.actions': '작업',
  'promotions.invite.message': 'ArChat에 여러분을 초대합니다. 어떤 언어로든 말해보세요. 우리 둘 다 이익을 얻습니다.',
  'promotions.progress.pending': '보상을 잠금 해제하기 위한 대기 중인 초대가 있습니다.',
  'promotions.progress.in_progress': '귀하의 초대가 진행 중입니다. 실제 대화 후에 보상이 활성화됩니다.',
  'promotions.progress.remaining': '보상을 받으려면 {count}개의 대화가 더 필요합니다.',
  'promotions.progress.sent_count': '전송된',
  'promotions.progress.pending_count': '보류 중',
  'promotions.progress.in_progress_count': '진행 중',
  'promotions.progress.completed_count': '완전한',
  'promotions.banner.empty': '지금 시작하세요: 연락처를 초대하고 혜택을 누리세요.',
  'promotions.banner.pending': '보류 중인 초대가 있습니다. 실제 대화를 완료하고 보상을 받으세요.',
  'promotions.banner.reward': '이미 보상을 잠금 해제했습니다! 당신의 이익을 증가시키기 위해 계속 초대하십시오.',
  'promotions.cta.copy': '메시지 및 링크 복사',
  'promotions.cta.copied': '메시지가 복사되었습니다.',
  'promotions.cta.copy_error': '메시지를 복사할 수 없습니다.',

  'promotions.title': '프로모션 및 보상',
  'promotions.subtitle': '실제 사용을 통해 연락처를 초대하고 혜택을 누려보세요.',
  'promotions.how_it_works': '작동 원리',
  'promotions.step1': '프로필에서 연락처를 초대하세요.',
  'promotions.step2': '실제 상호 작용을 수락하고 채팅하면 자동으로 검증됩니다.',
  'promotions.step3': '보상이 적립되고 진행 상황이 업데이트됩니다.',
  'promotions.rewards.title': '보상',
  'promotions.reward.invite': '검증된 각 추천에 대한 보상입니다.',
  'promotions.reward.milestone': '성장 이정표에 대한 보너스.',
  'promotions.reward.ranking': '최고의 네트워크 빌더 순위에 대한 가시성.',
  'promotions.progress.title': '귀하의 진행 상황',
  'promotions.progress.sent': '전송된',
  'promotions.cta.invite': '연락처 초대',
  'promotions.banner': '프로모션 활성화: 초대하고 실제 사용에 대한 보상을 받으세요.',
  'promotions.modal.title': '프로모션 프로그램',
  'promotions.modal.body': '확인된 초대당 +10.000자를 획득하세요.\\\\n지금 초대하고 보상을 잠금 해제하세요.',
  'promotions.modal.cta': '프로모션 보기',
                "app.install_ios_hint": "설치하려면: 공유 > 홈 화면에 추가",
                'menu.promotions': '프로모션',
                "suggestions.new": "새로운 제안",
                "suggestions.empty": "아직 제출된 제안이 없습니다.",
                "suggestions.admin_note": "팀 노트",
                "suggestions.status.pending": "귀걸이",
                "suggestions.status.reviewed": "개정됨",
                "suggestions.status.planned": "예정",
                "suggestions.status.implemented": "구현됨",
                "suggestions.status.rejected": "거부됨",
                "referral.promo": "초대하고 10,000자를 획득하세요",
                "referral.stats.sent": "전송된",
                "referral.stats.accepted": "수락됨",
                "referral.stats.rewards": "보상",
                "referral.reward.pending": "귀걸이",
                "referral.reward.granted": "채우는",
                "referral.reward.invalid": "유효하지 않은",
                "referral.reward.in_progress": "사용 중",
                "referral.limit.reached": "보상 한도 도달",
                "referral.waiting.usage": "귀하와 손님이 동일한 채팅에서 하나 이상의 실제 문자 메시지를 보낼 때 각각 +10,000자(서버 검증)",
                "common.avatar": "화신",
                "plan.free_characters_month": "30,000 characters / month",
                "plan.pro_characters_month": "300,000 characters / month",
                "messages.empty": "아직 메시지가 없습니다",
                "messages.loading": "메시지 로드 중...",
                "messages.connecting_server": "메시지 서버에 연결하는 중...",
                "messages.pending_send_count": "배달 대기 중인 메시지 {count}개",
                "presence.custom.suggestion.coffee": "친구 사귀기 ☺",
                "presence.custom.suggestion.soccer": "코트에서 ⚽",
                "presence.custom.suggestion.working": "미친듯이 일하고 💪",
                "presence.custom.suggestion.lunch": "점심을 먹고 🍽️",
                "presence.custom.suggestion.family": "가족 점심 👨‍👩‍👧‍👦",
                "presence.custom.suggestion.studying": "공부 중 📚",
                "presence.custom.suggestion.travel": "여행 중 ✈️",
                "presence.custom.suggestion.meeting": "회의 중 💼",
                "presence.custom.suggestion.resting": "쉬고 있어요 😴",
                "presence.custom.suggestion.gaming": "비디오 게임하기 🎮",
                "presence.custom.suggestion.reading": "독서 📖",
                "presence.custom.suggestion.offlineSoon": "금방 돌아올게요 ⏳",
                "invitation.safe.phase_notice": "활성 안전 단계: 상업적 활성화가 보류 중인 혜택(한도에 실제 영향은 없음)",
                "invitation.safe.generate_code": "링크/코드 생성",
                "invitation.safe.refresh_top3": "상위 3개 업데이트",
                "invitation.safe.top_loading": "최고 초대자 로드 중...",
                "invitation.safe.top_empty": "아직 추천된 초대 대상자가 없습니다.",
                "invitation.safe.hide_full_ranking": "전체 순위 숨기기",
                "invitation.safe.view_full_ranking": "전체 순위 보기",
                "invitation.safe.hide_metrics_dashboard": "측정항목 대시보드 숨기기",
                "invitation.safe.view_metrics_dashboard": "측정항목 대시보드 보기",
                "invitation.safe.prepared_link": "링크 준비됨",
                "invitation.safe.email_placeholder": "email@dominio.com",
                "invitation.safe.register_pending": "보류 중인 초대 등록",
                "invitation.safe.status_summary": "상태 요약",
                "invitation.safe.summary.pending": "귀걸이",
                "invitation.safe.summary.registered": "등기",
                "invitation.safe.summary.active": "활동적인",
                "invitation.safe.summary.validated": "검증됨",
                "invitation.safe.summary.rejected": "거부됨",
                "invitation.safe.sent_invitations": "초대장이 발행되었습니다",
                "invitation.safe.table.id": "ID",
                "invitation.safe.table.invited_email": "게스트 이메일",
                "invitation.safe.table.code": "암호",
                "invitation.safe.table.status": "상태",
                "invitation.safe.table.created": "생성됨",
                "invitation.safe.empty_sent": "아직 발행된 초대장이 없습니다.",
                "invitation.safe.simulated_rewards": "시뮬레이션된 보상 획득",
                "invitation.safe.empty_rewards": "현재로서는 시뮬레이션된 보상이 없습니다.",
                "invitation.safe.error.load_status": "초대 상태를 로드할 수 없습니다.",
                "invitation.safe.error.generate_code": "코드를 생성할 수 없습니다.",
                "invitation.safe.error.invalid_email": "초대장을 등록하려면 유효한 이메일을 입력하세요.",
                "invitation.safe.error.register_pending": "보류 중인 초대를 등록할 수 없습니다.",
                "invitation.safe.success.code_generated": "코드가 성공적으로 생성되었습니다.",
                "invitation.safe.success.pending_registered": "안전 모드에 등록된 대기 중인 초대입니다.",
                "invitation.status.deleted": "제거됨",
                "invitation.deleted.tooltip": "이 초대는 삭제되었습니다.",
                "invitation.status.rejected": "거부됨",
                "invitation.status.bounced": "반송됨",
                "invitation.status.unknown": "알 수 없는 상태",
                "dashboard.admin.title": "성장 지표",
                "dashboard.admin.newUsersToday": "오늘의 신규 사용자",
                "dashboard.admin.messagesSentToday": "오늘 보낸 메시지",
                "dashboard.admin.translationsUsed": "사용된 번역",
                "dashboard.admin.invitesCreated": "초대장이 생성되었습니다.",
                "dashboard.admin.invitesValidated": "검증된 초대장",
                "dashboard.admin.inviteConversion": "초대 전환",
                "dashboard.admin.kFactor": "K-인자",
                "dashboard.admin.newUsers": "신규 사용자",
                "dashboard.admin.messagesSent": "보낸 메시지",
                "dashboard.admin.noData": "데이터 없음",
                "dashboard.admin.kFactor.viral": "바이러스의",
                "dashboard.admin.kFactor.stable": "안정적인",
                "dashboard.admin.kFactor.low": "낮은",
                "dashboard.admin.emailMetrics": "이메일 지표",
                "dashboard.admin.email.sent": "전송된",
                "dashboard.admin.email.delivered": "배달됨",
                "dashboard.admin.email.opened": "열려 있는",
                "dashboard.admin.email.clicked": "클릭수",
                "dashboard.admin.email.bounced": "반송됨",
                "dashboard.admin.email.deliveryRate": "배송율",
                "dashboard.admin.email.openRate": "오픈율",
                "dashboard.admin.email.bounceRate": "반송률",
                "dashboard.admin.funnelMetrics": "유입경로 지표",
                "dashboard.admin.funnel.registered": "등기",
                "dashboard.admin.funnel.confirmed": "확인됨",
                "dashboard.admin.funnel.loggedIn": "첫 번째 로그인",
                "dashboard.admin.funnel.firstMessage": "첫 번째 메시지",
                "dashboard.admin.funnel.abandoned": "버려진",
                "dashboard.admin.funnel.conversionRate": "전환율",
                "dashboard.admin.funnel.activationRate": "활성화율",
                "dashboard.admin.funnel.dropoffRate": "탈락률",
                "dashboard.admin.loading": "측정항목 로드 중...",
                "dashboard.admin.errorLoad": "측정항목 대시보드를 로드할 수 없습니다.",
                "dashboard.admin.growthViral": "바이러스 성 성장",
                "dashboard.admin.growthStable": "안정적인 성장",
                "dashboard.admin.growthLow": "저성장",
                'upgrade.price.amount': '',
                'upgrade.price.period': '',
                "upgrade.enterprise.title": "ENTERPRISE",
                "errors.modal.code": "암호",
                "errors.modal.message": "메시지",
                "errors.modal.path": "노선",
                "errors.modal.time": "시간",
                "errors.modal.timestamp": "타임스탬프",
                "errors.modal.copied": "복사된 세부정보",
                "errors.network": "서버에 연결할 수 없습니다. 연결을 확인하세요.",
                "errors.unexpected": "예상치 못한 오류가 발생했습니다. 다시 시도해 보세요.",
                "errors.boundary.title": "반응 오류가 캡처되었습니다.",
                "errors.boundary.request_id": "X-요청-ID:",
                "errors.boundary.correlate": "backend/logs/structured.log에 매핑",
                "errors.boundary.message_label": "메시지:",
                "errors.boundary.stack_trace": "스택 추적",
                "errors.boundary.component_stack": "구성 요소 스택",
                "errors.boundary.empty": "(비어 있는)",
                "errors.boundary.reload_page": "페이지 새로고침",
                "errors.ui_boundary.refresh": "ArChat 인터페이스 오류 — 페이지 새로고침",
                "bootstrap.error.title": "ArChat® — 부팅 오류",
                "common.reload": "재충전",
                "admin.access_denied.message": "메시지",
                "admin.access_denied.title": "제목",
                "admin.action.change_plan": "계획 변경",
                "admin.action.reactivate": "재활성화",
                "admin.action.suspend": "유예하다",
                "admin.action.view": "보다",
                "admin.confirm.change_plan.message": "메시지",
                "admin.confirm.change_plan.title": "제목",
                "admin.confirm.suspend.message": "메시지",
                "admin.confirm.suspend.title": "제목",
                "admin.details.created": "생성됨",
                "admin.details.current_plan": "현재 계획",
                "admin.details.domain": "도메인",
                "admin.details.last_activity": "마지막 활동",
                "admin.details.name": "참마",
                "admin.details.plan": "계획",
                "admin.details.status": "상태",
                "admin.details.subscription": "신청",
                "admin.details.tenant_id": "테넌트 ID",
                "admin.details.tenant_info": "임차인 정보",
                "admin.details.usage": "용법",
                "admin.error.change_plan": "계획 변경",
                "admin.error.generic": "일반적인",
                "admin.error.load_details": "세부정보 로드",
                "admin.error.load_tenants": "테넌트 로드",
                "admin.error.reactivate": "재활성화",
                "admin.error.suspend": "유예하다",
                "admin.error.title": "제목",
                "admin.filter.active": "활성화",
                "admin.filter.all_plans": "모든 계획",
                "admin.filter.all_status": "모든 상태",
                "admin.filter.suspended": "유예하다",
                "admin.limit.devices": "장치",
                "admin.limit.invitations": "초대장",
                "admin.limit.messages": "메시지",
                "admin.limit.storage": "저장",
                "admin.limit.users": "사용자",
                "admin.loading": "로드 중",
                "admin.no_tenants": "비임차인",
                "admin.plan.enterprise": "Enterprise",
                "admin.plan.free": "Free",
                "admin.plan.pro": "Pro",
                "admin.status.active": "활성화",
                "admin.status.suspended": "유예하다",
                'admin.subscription.id': 'Id',
                "admin.subscription.last_payment": "마지막 결제",
                "admin.subscription.status": "상태",
                "admin.subtitle": "부제",
                "admin.success.plan_changed": "계획이 변경됨",
                "admin.success.tenant_reactivated": "테넌트가 재활성화됨",
                "admin.success.tenant_suspended": "임차인 정지",
                "admin.success.title": "제목",
                "admin.table.actions": "행위",
                "admin.table.messages": "메시지",
                "admin.table.name": "참마",
                "admin.table.plan": "계획",
                "admin.table.status": "상태",
                "admin.table.storage": "저장",
                "admin.table.tenant_id": "테넌트 ID",
                "admin.table.users": "사용자",
                "admin.title": "제목",
                "admin.usage.devices": "장치",
                "admin.usage.invitations": "초대장",
                "admin.usage.messages": "메시지",
                "admin.usage.storage": "저장",
                "admin.usage.users": "사용자",
                "auth.login": "로그인",
                "auth.register": "등록하다",
                "auth.reset_password": "비밀번호 재설정",
                "billing.cancel.button": "단추",
                "billing.cancel.canceling": "취소 중",
                "billing.cancel.confirm": "확인하다",
                "billing.cancel.error": "실수",
                "billing.cancel.success": "성공",
                "billing.character_billing.characters_used": "사용된 문자",
                "billing.character_billing.consumption_pct": "소비량",
                "billing.character_billing.days_remaining": "남은 일수",
                "billing.character_billing.deletion_date": "삭제일",
                "billing.character_billing.period_start": "기간 시작",
                "billing.character_billing.renewal_date": "갱신일",
                "billing.character_billing.title": "제목",
                "billing.current_plan": "현재 계획",
                "billing.founder_badge": "창립자 배지",
                "billing.no_plans": "계획하지 마세요",
                'billing.subscription.canceled': 'Canceled',
                'billing.subscription.canceled_note': 'Canceled note',
                "billing.subscription.next_payment": "다음 결제",
                "billing.subscription.plan": "계획",
                'billing.subscription.price': '요금제 가격',
                "billing.subscription.started": "시작됨",
                "billing.subscription.status": "상태",
                "billing.subscription.mp_flow.subscribe_failed": "구독을 시작할 수 없습니다. 다시 시도해 보세요.",
                "billing.subscription.mp_flow.change_plan_failed": "계획은 변경할 수 없습니다. 다시 시도해 보세요.",
                "billing.subscription.mp_status.pending": "귀걸이",
                "billing.subscription.mp_status.authorized": "인정 받은",
                "billing.subscription.mp_status.active": "활동적인",
                "billing.subscription.mp_status.paused": "일시중지됨",
                "billing.subscription.mp_status.cancelled": "취소",
                "billing.subscription.mp_status.inactive": "비활성",
                "billing.subscription.mp_status.unknown": "낯선 사람",
                "billing.unlimited": "제한 없는",
                "billing.update_plan": "업데이트 계획",
                "billing.update_plan_modal.title": "제목",
                "billing.usage.loading": "로드 중",
                "common.accept": "수용하다",
                "common.confirmPassword": "비밀번호 확인",
                'common.continue': '계속',
                "common.error": "실수",
                "dashboard.upgrade.to_plan": "계획하다",
                "emoji.noResults": "결과 없음",
                "emoji.pick": "선택하다",
                "export.restricted.message": "메시지",
                "export.restricted.title": "제목",
                "export.restricted.upgrade": "치받이",
                "founder.*": "*",
                "help.faq.a1": "A1",
                "help.faq.a2": "A2",
                "help.faq.a3": "A3",
                "help.faq.a4": "A4",
                "help.faq.a5": "A5",
                "help.faq.a6": "A6",
                "help.faq.a7": "A7",
                "help.faq.q1": "1분기",
                "help.faq.q2": "2분기",
                "help.faq.q3": "3분기",
                "help.faq.q4": "4분기",
                "help.faq.q5": "Q5",
                "help.faq.q6": "Q6",
                "help.faq.q7": "Q7",
                "help.faq.title": "제목",
                "help.howWorks.step4.point7": "Point7",
                "help.message_time_context.free_vs_pro": "무료 대 프로",
                "help.message_time_context.point5": "Point5",
                "help.plans.enterprise.benefits": "이익",
                "help.plans.enterprise.description": "설명",
                "help.plans.enterprise.title": "제목",
                "help.plans.foundation.devices": "장치",
                "help.plans.free.description": "설명",
                "help.plans.free.devices": "장치",
                "help.plans.free.limits": "제한",
                "help.plans.free.title": "제목",
                "help.plans.intro": "소개",
                "help.plans.pro.benefits": "이익",
                "help.plans.pro.description": "설명",
                "help.plans.pro.devices": "장치",
                'help.plans.pro.price': '월 $19',
                "help.plans.pro.title": "제목",
                "help.plans.pro.upgrade": "치받이",
                "help.plans.title": "제목",
                "help.plans.urgent_slots_badge": "긴급 슬롯 배지",
                "help.slogan.final": "끝",
                "help.suggestions.point1": "포인트1",
                "help.suggestions.point2": "포인트2",
                "help.suggestions.title": "제목",
                "invitation.already_contact_added": "이미 연락처가 추가되었습니다.",
                "invitation.already_contact_title": "이미 연락처 제목",
                "invitation.already_pending": "이미 보류 중",
                "invitation.language.invalid": "유효하지 않은",
                "message.send": "보내다",
                "message.sendFile": "SendFile",
                "messages.conversations": "대화",
                "messages.no_conversations_subtitle": "대화 자막 없음",
                "messages.no_conversations_title": "대화 제목 없음",
                "presence.custom.edit": "편집하다",
                "profile.enrichment.country": "국가",
                "profile.enrichment.country.select": "선택하다",
                "profile.enrichment.description": "설명",
                "profile.enrichment.org_size": "조직 규모",
                "profile.enrichment.org_size.placeholder": "자리 표시자",
                "profile.enrichment.save": "구하다",
                "profile.enrichment.skip": "건너뛰다",
                "profile.enrichment.title": "제목",
                "profile.enrichment.usage_type.label": "상표",
                "profile.enrichment.usage_type.placeholder": "자리 표시자",
                "profile.founderPosition": "설립자직위",
                "settings.confirmations.description": "설명",
                "settings.confirmations.disable": "장애를 입히다",
                "settings.confirmations.title": "제목",
                "settings.confirmations.updated": "업데이트됨",
                "settings.title": "제목",
                "theme.description": "설명",
                "google.unavailable_tenant": "이 테넌트는 Google을 사용할 수 없습니다.",
                "google.unavailable": "Google을 사용할 수 없습니다.",
                "google.verify_client_id": "Google Cloud Console에서 클라이언트 ID를 확인합니다.",
                'google.login_aria': 'Google로 로그인',
                "message.preview_alt": "시사",
                "message.image_attachment_alt": "첨부된 이미지",
                "profile.avatar.alt": "화신",
                "plan.name.free": "FREE",
                "plan.name.pro": "PRO",
                "plan.name.foundation": "FOUNDATION",
                "plan.name.enterprise": "ENTERPRISE",
                "register.emailPlaceholder": "you@email.com",
                "invitation.top.loading": "최고 초대자 로드 중...",
                "invitation.top.empty": "아직 추천 초대자가 없습니다.",
                "invitation.contacts.title": "연락처 초대",
                "invitation.contacts.safe_phase_note": "안전 단계 활성: 실제 한도에 영향을 주지 않고 보류 중인 혜택입니다.",
                "invitation.contacts.generate_code": "코드/링크 생성",
                "invitation.contacts.refresh_top3": "상위 3개 새로 고침",
                "invitation.contacts.hide_full_ranking": "전체 순위 숨기기",
                "invitation.contacts.show_full_ranking": "전체 순위 표시",
                "invitation.contacts.hide_metrics_dashboard": "측정항목 대시보드 숨기기",
                "invitation.contacts.show_metrics_dashboard": "측정항목 대시보드 표시",
                "invitation.contacts.prepared_link_label": "준비된 링크:",
                "invitation.contacts.email_placeholder": "이메일@도메인.com",
                "invitation.contacts.register_pending": "보류 중인 초대 등록",
                "invitation.contacts.status_summary": "상태 요약",
                "invitation.contacts.sent_invitations": "초대장을 보냈습니다",
                "invitation.contacts.invited_email": "초대 이메일",
                "invitation.contacts.code": "암호",
                "invitation.contacts.no_sent_invitations": "아직 초대장을 보내지 않았습니다.",
                "invitation.contacts.simulated_rewards": "시뮬레이션 보상 획득",
                "invitation.contacts.no_simulated_rewards": "아직 시뮬레이션된 보상이 없습니다.",
                "common.id": "ID",
                "common.created": "생성됨",
                'plan.pro_contacts': '사용자당 최대 100명의 연락처',
                "common.status": "상태",
                "login.prompt_create_account_with_name": "이 이름으로 계정을 만드시겠습니까?",
                'plans.upgrade.title': '요금제 업그레이드',
                'plans.upgrade.comparison': '요금제 비교',
                'plans.upgrade.billing': '',
                'plans.upgrade.cancel_anytime': '언제든지 취소 가능',
                'plans.actions.upgrade_pro': 'PRO로 업그레이드',
                'plans.actions.become_founder': 'Founder 되기',

                'plans.modal.card.current_badge': '현재 요금제',

                'plans.modal.card.lower_tier': '사용 중 요금제보다 낮음',

                'plans.modal.card.manage_in_profile': '변경 또는 해지: 프로필의 구독 및 결제에서.',
                'plans.modal.card.cancel_subscription': '구독 취소',
                'plans.modal.cancel_confirm.title': '구독 취소 또는 관리',
                'plans.modal.cancel_confirm.body': '새 탭에서 안전한 Paddle 포털이 열리며 결제 수단, 청구서 확인 또는 구독 해지를 할 수 있습니다.',
                'plans.modal.cancel_confirm.continue_button': '계속',
                'plans.modal.cancel_confirm.back_button': '돌아가기',
                'plans.modal.cancel_paddle_fallback.title': '구독 관리',
                'plans.modal.cancel_paddle_fallback.body': '이 환경에서는 Paddle 결제 포털이 열리지 않습니다(로컬 개발 또는 미연결 등). 이 화면에서 요금제를 계속 확인·비교할 수 있습니다.',
                'plans.modal.cancel_paddle_fallback.confirm': '확인',
                'plans.upgrade_required': 'PRO 요금제에서 이용 가능',
                'settings.heading': '설정',
                'settings.dashboard': '대시보드',
                'settings.dashboardDescription': '홈 패널과 보이는 블록에 대한 로컬 설정입니다.',
                'settings.dashboardGridHeading': '패널 블록',
                'settings.dashboardShowOnStartDescription': '켜면 로그인 후 연락처 목록 대신 대시보드를 엽니다.',
                'settings.dashboardBlockWelcome': '환영',
                'settings.dashboardBlockUsage': '플랜 사용량',
                'settings.dashboardBlockFiles': '내 파일',
                'settings.dashboardBlockPromotions': '프로모션',
                'settings.dashboardBlockSessions': '세션',
                'settings.dashboardWelcomeDescription': '시작하기, 연락처 초대, 도움말 바로가기.',
                'settings.dashboardUsageDescription': '한도 대비 사용량: 연락처, 글자 수, 저장소, 기기.',
                'settings.dashboardFilesDescription': '‘내 파일’의 보이는 파일과 용량 요약.',
                'settings.dashboardPromotionsDescription': '프로모션 요약 및 프로그램 링크.',
                'settings.dashboardSessionsDescription': '활성 세션과 기기. 가능 시 다른 세션 종료.',
                'settings.enabled': '켜짐',
                'settings.disabled': '꺼짐',
                'settings.showDashboardOnStart': '로그인 시 대시보드 표시',
                'settings.showWelcomeBlock': '환영 블록',
                'settings.showPromotionsBlock': '프로모션 블록',
                'settings.showUsageBlock': '요금제 사용량',
                'settings.showRecentConversationsBlock': '최근 대화 표시(연락처별 마지막 메시지)',
                'settings.showSessionsBlock': '활성 세션',
                'settings.showFilesBlock': '파일 요약',
                'settings.dashboardLocalNote': '프로필 API가 생길 때까지 이 브라우저(로컬)에만 저장됩니다.',
                'settings.appearanceSettings': '모양',
                'settings.argentinaTheme': '아르헨티나 테마',
                'settings.darkMode': '다크 모드',
                'settings.language': '언어',
                'settings.messageSound': '메시지 소리',
                'settings.playSoundDescription': '새 메시지나 중요한 알림에 소리를 재생합니다.',
                'settings.messageSoundEnabled': '켜짐',
                'settings.messageSoundDisabled': '꺼짐',
                'settings.accountSettings': '계정',
                'settings.deleteAccount': '계정 삭제',
                'settings.deleteAccountWarning': '이 작업은 영구적입니다. 데이터, 메시지, 연락처 및 설정은 플랫폼 삭제 절차에 따라 제거됩니다.',
                'settings.deleteMyAccount': '내 계정 삭제',
                'dashboard.contacts': '연락처',
                'dashboard.characters': '문자 수',
                'dashboard.storage': '저장 공간',
                'dashboard.active_devices': '활성 기기',
                'dashboard.need_more_resources': '더 많은 리소스가 필요하신가요?',
                'dashboard.upgrade_message': '더 많은 연락처, 문자 수, 저장 공간, 활성 기기를 위해 요금제를 업그레이드하세요.',
                'dashboard.upgrade_button': 'PRO로 업그레이드',
                'dashboard.upgrade_button_pro': 'PRO로 업그레이드',
                'dashboard.upgrade_button_foundation': 'FOUNDATION으로 업그레이드',
                'files.preview': '미리보기',
                'files.previewFile': '파일 미리보기',
                'files.previewUnavailable': '미리보기를 사용할 수 없습니다.',
                'files.previewLoading': '미리보기 로딩 중…',
                'files.openPreview': '미리보기',
                'files.downloadFile': '파일 다운로드',
                'files.downloadFailed': '파일을 다운로드할 수 없습니다. 연결과 로그인 상태를 확인한 뒤 다시 시도하세요.',
                'files.closePreview': '미리보기 닫기',
                'files.unsupportedPreview': '이 유형의 파일은 미리보기가 없습니다. 정보를 보거나 다운로드하세요.',
                'files.pdfPreviewHelp': '브라우저가 PDF를 끼워 넣어 보여주지 않을 수 있습니다. 열려면 다운로드하세요.',
                'files.labelFileType': '유형',
                'files.previewForbidden': '미리보기 권한이 없습니다.',
                'files.previewNotFound': '파일을 사용할 수 없거나 계정에 더 이상 표시되지 않습니다.',
                'files.unavailableForFree': '내 파일은 FREE 요금제에 포함되지 않습니다.',
                'files.availableInFoundationAndPro': '내 파일은 FOUNDATION 및 PRO에서 이용할 수 있습니다.',
                'files.filesFeatureRestricted': '현재 요금제에서는 이 기능을 사용할 수 없습니다.',
                'files.filesLoadError': '파일을 불러오는 중 오류가 발생했습니다.',
                'files.uploadUnavailableForFree': 'FREE 요금제에서는 파일을 보낼 수 없습니다.',
                'files.uploadAvailableInFoundationAndPro': '파일 전송은 FOUNDATION과 PRO에서 가능합니다.',
                'files.recipientStorageFull': '받는 사람에게 이 파일을 받을 여유 공간이 없습니다.',
                'files.recipientNoAvailableStorage': '받는 사람에게 이 파일을 받을 여유 공간이 없습니다.',
                'files.storageQuotaExceeded': '요금제 저장 공간 한도에 도달했습니다.',
                'files.freeStorageLimit': 'FREE 요금제에는 받은 파일용 5MB가 포함됩니다.',
                'settings.unreadEmailReminderSection': '읽지 않은 메시지 요약 이메일',
                'settings.unreadEmailReminderDescription': '새 메시지나 파일을 아래 시간보다 오래 읽지 않으면 ArChat이 하나의 요약 이메일을 보냅니다(메시지마다 보내지 않음).',
                'settings.unreadEmailReminderToggle': '요약을 이메일로 받기',
                'settings.unreadEmailDelayHours': '보내기 전 대기(시간)',
                'settings.unreadEmailDelayHint': '1–168시간(최대 1주). 이메일 언어는 프로필과 동일.',
                'subjects.title': '주제',
                'subjects.singular': '주제',
                'subjects.plural': '주제',
                'subjects.general': '일반',
                'subjects.new': '새 주제',
                'subjects.create': '주제 만들기',
                'subjects.rename': '이름 바꾸기',
                'subjects.finish': '완료',
                'subjects.reopen': '다시 열기',
                'subjects.select': '계속',
                'subjects.status.open': '열림',
                'subjects.status.pending': '대기',
                'subjects.status.finished': '완료됨',
                'subjects.limitReached': '이 대화에서 활성 주제 한도에 도달했습니다. 주제를 종료한 뒤 새로 만드세요.',
                'subjects.limitReachedFree': 'FREE 요금제는 대화당 활성 주제 최대 3개입니다. 주제를 종료한 뒤 새로 만드세요.',
                'subjects.limitReachedPro': 'PRO 요금제는 대화당 활성 주제 최대 5개입니다. 주제를 종료한 뒤 새로 만드세요.',
                'subjects.limitReachedFoundation': 'FOUNDATION 요금제는 대화당 활성 주제 최대 5개입니다. 주제를 종료한 뒤 새로 만드세요.',
                'subjects.activeLimitsLine': '활성 주제: {current} / {max}',
                'subjects.closedListTitle': '종료된 주제',
                'subjects.viewClosed': '종료된 주제 보기',
                'subjects.noClosedSubjects': '종료된 주제가 없습니다.',
                'subjects.reopenSubject': '다시 열기',
                'subjects.reopenedSubjects': '다시 연 주제',
                'subjects.reopenLimitReached':
                  '활성 주제 한도에 도달했습니다. 이 주제를 다시 열려면 다른 주제를 종료하세요.',
                'subjects.ownerOnlyReopen': '이 주제를 만든 사람만 다시 열 수 있습니다.',
                'subjects.modal.title': '대화 주제',
                'subjects.modal.subtitle': '이 대화의 주제를 선택하거나 관리합니다.',
                'subjects.contactLabel': '연락처:',
                'subjects.ownerOnlyRename': '주제를 만든 사람만 이름을 바꿀 수 있습니다.',
                'subjects.ownerOnlyStateChange': '주제를 만든 사람만 상태를 변경할 수 있습니다.',
                'subjects.createdByOther': '이 주제는 상대방이 만들었습니다. 답장은 할 수 있지만 이름은 바꿀 수 없습니다.',
                'subjects.empty': '표시할 주제가 없습니다.',
                'subjects.noResults': '주제를 찾을 수 없습니다.',
                'subjects.error.generic': '작업을 완료할 수 없습니다. 다시 시도하세요.',
                'subjects.error.featureDisabled': '이 환경에서는 주제를 사용할 수 없습니다.',
                'subjects.error.duplicateName': '이미 같은 이름의 활성 주제가 있습니다.',
                'subjects.error.ownerRequired': '이 주제를 수정할 권한이 없습니다.',
                'subjects.error.defaultCannotRename': '일반 주제의 이름을 바꿀 수 없습니다.',
                'subjects.error.defaultCannotFinish': '일반 주제를 완료할 수 없습니다.',
                'subjects.current': '주제',
                'subjects.change': '주제 변경',
                'subjects.currentLabel': '주제:',
                'subjects.changeSubject': '주제 변경',
                'subjects.closedCannotSend': '이 주제가 종료되었습니다. 새 메시지를 보내려면 다시 여세요.',
                'subjects.selectBeforeSend': '모달에서 주제를 선택하면 메시지를 보고 보낼 수 있습니다.',
                'subjects.loadingMessages': '이 주제의 메시지를 불러오는 중…',
                'subjects.messageFilterError': '이 주제의 메시지를 불러오지 못했습니다.',
                ...PRESET_LOCALES.ko,
                "auth.login.clear_password_lock_after_reset": "이미 비밀번호를 변경했습니다(예: 다른 기기에서).",
                "auth.signup_disabled": "이 환경에서는 신규 계정 등록이 일시적으로 비활성화됩니다.",
                "auth.reset_user_not_found": "해당 이메일과 연결된 계정을 찾지 못했습니다. 철자가 올바른지 확인하거나 새 계정을 만드세요.",
                "account.not_found": "계정을 찾을 수 없습니다.",
                "auth.pending_activation.title": "활성화 보류 중인 계정",
                "auth.pending_activation.body": "귀하의 계정은 아직 활성화되지 않았습니다. ArChat에 입장하려면 이메일을 확인하고 등록을 확인하세요.",
                "auth.pending_activation.back_to_login": "로그인으로 돌아가기",
                "auth.pending_activation.support_prefix": "도움이 필요하신가요? 지원팀에 문의하세요:",
                "auth.pending_activation.support_email": "info@archat.com.ar",
                "auth.pending_activation.email_label": "활성화를 다시 보내려면 이메일을 보내세요",
                "auth.pending_activation.email_placeholder": "tu@email.com",
                "auth.pending_activation.email_required": "활성화를 다시 보내려면 등록한 이메일을 입력하세요.",
                "auth.pending_activation.sent_title": "활성화 이메일이 전송되었습니다",
                "auth.pending_activation.sent_body": "이메일이 보류 중인 계정에 해당하는 경우 새 활성화 링크를 보내드립니다. 받은 편지함과 스팸 또는 정크 메일도 확인하세요.",
                "auth.pending_activation.soft_error_title": "재전송 불가",
                "auth.pending_activation.soft_error_body": "지금은 재전송을 처리할 수 없습니다. 몇 분 후에 다시 시도하거나 info@archat.com.ar로 메일을 보내주세요.",
                "auth.pending_activation.resend_again": "다시 보내기",
                "menu.plans": "계획",
                "files.title": "내 파일",
                "files.filter_all": "모두",
                "files.filter_sent": "전송된",
                "files.filter_received": "받았다",
                "files.filter_images": "이미지",
                "files.filter_documents": "서류",
                "files.col_name": "이름",
                "files.col_size": "크기",
                "files.col_date": "날짜",
                "files.col_direction": "감독",
                "files.col_actions": "행위",
                "files.sent": "📤 보냄",
                "files.received": "📥 접수됨",
                "files.download": "해고하다",
                "files.delete_for_me": "나를 위해 삭제",
                "files.delete_confirm_title": "파일 삭제",
                "files.delete_confirm_message": "이 파일은 귀하의 계정에서 삭제됩니다. 상대방을 위해 삭제되지 않습니다. 계속하다?",
                "files.empty": "파일이 없습니다.",
                "files.error_loading": "파일을 업로드하는 중에 오류가 발생했습니다.",
                "files.load_more": "더 로드하기",
                "message.status.sending": "배상…",
                "message.status.failed": "전송되지 않음",
                "message.status.sent": "전송된",
                "message.status.delivered": "배달됨",
                "message.status.read": "읽다",
                "home.public_nav.pricing": "물가",
                "home.public_nav.aria": "주요 사이트 탐색",
                "home.public_footer.aria": "법적 링크",
                "home.pricing_link": "계획 및 가격",
                "publicPricing.nav.back_home": "← 홈",
                "publicPricing.title": "계획 및 가격",
                "publicPricing.subtitle": "ArChat 구독 엔진에 대한 투명하고 조정된 제한. 국제 결제에 대한 상업 가격은 미국 달러입니다(예: 패들).",
                "publicPricing.commercial_note": "기능적 경계는 PlanConstants/PlanResolver에서 나옵니다. 귀하의 계정은 데이터베이스에 plan_limits를 적용할 수 있습니다. 판매자 청구는 표시된 대로 USD 가격으로 Paddle(또는 ArChat에서 공식적으로 지정한 기타 프로세서)을 사용합니다.",
                "publicPricing.plan.free": "FREE",
                "publicPricing.plan.foundation": "FOUNDATION",
                "publicPricing.plan.pro": "PRO",
                "publicPricing.price.free": "USD 0 / mes",
                "publicPricing.price.foundation": "USD {price} / mes",
                "publicPricing.price.pro": "USD {price} / mes",
                "publicPricing.same_limits_pro": "PRO(프리미엄 계약)와 동일한 기술 제한.",
                "publicPricing.same_limits_foundation": "FOUNDATION(프리미엄 계약)과 동일한 기술적 한계.",
                "publicPricing.badge.foundation": "Programa Founder",
                "publicPricing.badge.pro": "Recomendado",
                "publicPricing.free.b1": "계정당 월 30,000자입니다.",
                "publicPricing.free.b2": "사용자당 최대 2개의 연락처; 계정당 최대 2개의 활성 대화.",
                "publicPricing.free.b3": "첨부 파일이나 저장 공간이 없습니다. 데이터 내보내기 없이.",
                "publicPricing.free.b4": "메시지 기록은 최대 30일입니다. 사용자당 1개의 기기.",
                "publicPricing.free.b5": "메시지 34개/일 및 메시지 1,000개/월(테넌트) 하루에 최대 20명까지 초대할 수 있습니다.",
                "publicPricing.premium.b1": "계정당 월 300,000자; 사용자당 최대 100개의 연락처.",
                "publicPricing.premium.b2": "무제한 대화 및 채팅(임차인) 메시지 1,667개/일, 50,000개/월.",
                "publicPricing.premium.b3": "최대 50MB의 스토리지(테넌트) 사용자당 최대 3개의 장치.",
                "publicPricing.premium.b4": "무제한 초대(임차인) 계획에 따라 내보내기, 자동 번역 및 파일.",
                "publicPricing.premium.b5": "FOUNDATION: PRO와 동일한 기술 계약 및 Founder 프로그램(150개 장소). PRO: 프리미엄 표준.",
                "publicPricing.foundation.founder_note": "창립자 상업 프로그램: 제한된 수의 {slots} 장소(계획 요약 참조). 구독이 활성화되면 동일한 PRO 한도가 적용됩니다.",
                "publicPricing.cta.start_free": "무료 계정 만들기",
                "publicPricing.cta.register_paid": "계정 만들기",
                "publicPricing.paddle_hint": "충전이 활성화되면 애플리케이션 내에서 선택한 프로세서로 결제가 완료됩니다.",
                "publicPricing.legal.nav_label": "합법적인",
                "publicPricing.legal.terms": "서비스 약관",
                "publicPricing.legal.privacy": "개인 정보 보호 정책",
                "publicPricing.legal.refund": "환불 정책",
                "profile.security.privacy_note": "계정의 개인정보 보호 및 보안을 관리하세요.",
                "profile.security.sessions_title": "활성 세션",
                "profile.security.current": "현재 세션",
                "profile.plan.foundation.description": "FOUNDATION 플랜(Founder): PRO와 동일한 프리미엄 사용, Founder 프로그램 및 제한된 공간(150석).",
                "billing.view_plans": "요금제 보기",
                "billing.paddle.cancel_via_portal": "구독 취소",
                "billing.paddle.test_access_denied_body": "이 서버에서는 결제 작업(테스트 모드 또는 테스트 목록)이 제한됩니다. 이미 실제 계좌로 결제한 경우 프로덕션에서는 모든 사용자(예: PAYMENTS_ALLOW_ALL_BILLING_USERS)에 대해 결제를 허용하거나 해당 제한을 비활성화해야 합니다. 지원팀에 문의하세요.",
                "attachment.storage_insufficient_precheck.title": "공간이 부족함",
                "attachment.storage_insufficient_precheck.message": "파일 무게는 {fileSizeMb}MB이고 사용 가능한 용량은 {availableMb}MB입니다. 계속하려면 여유 공간을 확보하거나 계획을 개선하세요.",
                "attachment.files_disabled.title": "요금제 한도",
                "attachment.files_disabled.message": "현재 계획에는 파일 전송이 포함되지 않습니다. 계속하려면 계획을 개선하세요.",
                "contacts.viewContactInfo": "연락처 세부정보 보기",
                "contacts.contactInfoTitle": "연락처 세부정보",
                "contacts.phone": "핸드폰",
                "contacts.bio": "전기",
                "contacts.notProvided": "정보가 없음",
                "contacts.unread.badge": "읽지 않은 메시지",
                "dashboard.recentInbound.title": "마지막으로 받은 메시지",
                "dashboard.recentInbound.empty": "최근 받은 메시지가 없습니다.",
                "dashboard.recentInbound.error": "메시지를 로드할 수 없습니다.",
                "dashboard.recentInbound.previewPhoto": "사진",
                "dashboard.recentInbound.previewFile": "보관소",
                "dashboard.recentInbound.previewPdf": "PDF",
                "dashboard.recentInbound.previewUnavailable": "메시지를 사용할 수 없습니다.",
                "dashboard.recentInbound.readTitle": "읽다",
                "dashboard.recentInbound.unreadTitle": "읽히지 않는",
                "dashboard.recentConversations.title": "최근 대화",
                "dashboard.recentConversations.empty": "표시할 대화가 없습니다.",
                "dashboard.recentConversations.error": "대화를 로드할 수 없습니다.",
                "dashboard.plan.foundation": "FOUNDATION",
                "plan.errors.translationNotAllowed.title": "번역할 수 없음",
                "plan.errors.translationNotAllowed.message": "현재 계획에는 언어 간 자동 번역이 포함되어 있지 않습니다.",
                "plan.errors.translationNotAllowed.solution": "자동 번역을 사용하려면 요금제를 업그레이드하세요.",
                "billing.subscription.cancel_scheduled_date": "귀하의 구독은 {{date}}에 취소될 예정입니다. 그때까지는 요금제를 계속 사용할 수 있습니다.",
                "billing.subscription.cancel_scheduled_badge": "{{date}}에 취소됨",
                "billing.scheduled.plan_after_cancel_label": "기간 종료 시 계획:",
                "billing.scheduled.plan_free": "FREE (gratuito)",
                "billing.scheduled.plan_foundation": "FOUNDATION",
                "billing.scheduled.switch_to_foundation": "파운데이션으로 변경",
                "billing.scheduled.switch_to_free": "무료로 변경",
                "billing.scheduled.foundation_full_title": "파운데이션을 사용할 수 없습니다",
                "billing.scheduled.foundation_full_message": "현재 이용 가능한 FOUNDATION 지점이 없습니다. 기간이 끝나면 귀하의 계획은 무료로 내려갑니다.",
                "billing.scheduled.saving": "절약...",
                "billing.scheduled.error_title": "요금제 변경 중 오류가 발생했습니다.",
                "billing.scheduled.error_generic": "예정된 계획을 변경할 수 없습니다. 다시 시도해 보세요.",
                "billing.cancel_scheduled.title": "취소 예정",
                "billing.cancel_scheduled.desc": "귀하의 구독이 {{date}}에 취소됩니다. 그때까지는 현재 요금제를 계속 사용할 수 있습니다.",
                "billing.cancel_scheduled.no_new_plan_until_end": "이 구독이 만료될 때까지 다른 플랜을 계약할 수 없습니다.",
                "billing.cancel_scheduled.free_fallback": "어떤 플랜도 갱신하지 않으면 귀하의 계정은 해당 제한사항과 함께 무료로 계속 유지됩니다.",
                "billing.cancel_scheduled.profile_deactivation_hint": "프로필에서 플랫폼 구독을 취소할 수도 있습니다.",
                "billing.cancel_scheduled.default_free": "기간 종료 시: 무료",
                "google.missing_client_id": "이 빌드에서는 Google 로그인을 사용할 수 없습니다. VITE_GOOGLE_CLIENT_ID(또는 __ARCHAT_TENANT_CONFIG__의 테넌트당 googleClientId)가 누락되었습니다.",
                "reviews.title": "ArChat 리뷰",
                "reviews.create_title": "ArChat을 어떻게 평가하시나요?",
                "reviews.edit_title": "내 리뷰 수정",
                "reviews.comment_placeholder": "귀하의 경험에 대해 알려주십시오(선택 사항)...",
                "reviews.submit_btn": "리뷰 제출",
                "reviews.update_btn": "업데이트",
                "reviews.thank_you": "리뷰를 남겨주셔서 감사합니다!",
                "reviews.submitted_message": "귀하의 의견은 우리가 개선하는 데 도움이 됩니다.",
                "reviews.error_select_rating": "등급을 선택하세요",
                "reviews.error_generic": "리뷰를 제출하는 중에 오류가 발생했습니다.",
                "reviews.prompt_message": "아르챗을 좋아하시나요? 리뷰를 남겨주세요!",
                "reviews.rate_now": "자격",
                "reviews.later": "나중에",
                "reviews.write_review": "리뷰 쓰기",
                "reviews.edit_my_review": "내 리뷰 수정",
                "reviews.no_reviews": "아직 리뷰가 없습니다. 첫 번째가 되세요!",
                "reviews.review_singular": "검토",
                "reviews.review_plural": "리뷰",
                "reviews.verified": "확인됨",
                "reviews.anonymous": "익명의",
                "files.storageUsed": "사용 공간",
                "files.planQuota": "계획 할당량",
                "files.availableStorage": "사용 가능",
                "files.usagePercent": "사용된",
                "files.unlimited": "제한 없는",
                "files.sentBy": "보낸 사람",
                "files.unknownUser": "사용자",
                "settings.webPushSection": "시스템 알림(푸시/PWA)",
                "settings.webPushDescription": "앱이 백그라운드에 있거나 모바일에서 닫혀 있을 때 알림을 허용합니다. 빌드에는 VAPID 공개 키(VITE_VAPID_PUBLIC_KEY)가 필요하고 서버에는 키가 필요합니다. 브라우저 권한을 활성화하고 이 장치를 등록하세요.",
                "settings.webPushButton": "푸시 알림 활성화",
                "settings.webPushRegistering": "등록 중…",
                "settings.webPushState.granted": "허가가 부여되었습니다. VAPID가 올바르게 설정되면 로그가 서버로 전송됩니다.",
                "settings.webPushState.denied": "허가가 거부되었습니다. 브라우저 설정에서 이 사이트에 대한 알림을 활성화하십시오.",
                "settings.webPushState.default": "버튼을 눌러 권한을 요청하고 기기를 등록하세요.",
                "settings.webPushState.unsupported": "이 브라우저는 푸시 알림을 지원하지 않습니다.",
                "settings.webPushVapidMissing": "이 프런트엔드 빌드에는 VITE_VAPID_PUBLIC_KEY가 없습니다. 푸시 구독을 완료할 수 없습니다.",
                "tags.etiquetas": "라벨",
                "tags.manageTitle": "태그 관리",
                "tags.manage": "🏷️ 태그",
                "tags.allTags": "모든 태그",
                "tags.confirmDelete": "이 태그를 삭제하시겠습니까?",
                "tags.tagNamePlaceholder": "태그 이름",
                "tags.create": "만들다",
                "tags.noTags": "라벨이 없습니다. 위에서 하나를 만듭니다.",
                "tags.save": "유지하다",
                "tags.edit": "편집하다",
                "tags.delete": "제거하다",
                "tags.assignTo": "할당 대상",
                "tags.noTagsToAssign": "사용 가능한 라벨이 없습니다. 먼저 생성하세요.",
                "tags.bgColor": "배경색",
                "tags.textColor": "텍스트 색상",
                "tags.selectTag": "라벨을 선택하세요",
                "templates.selectTitle": "템플릿",
                "templates.noTemplates": "템플릿이 없습니다. 위에서 하나를 만듭니다.",
                "templates.manage": "템플릿 관리",
                "templates.confirmDelete": "이 템플릿을 삭제하시겠습니까?",
                "templates.manageTitle": "템플릿 관리",
                "templates.titlePlaceholder": "템플릿 제목",
                "templates.bodyPlaceholder": "템플릿 메시지를 작성했습니다.",
                "templates.create": "템플릿 만들기",
                "templates.save": "유지하다",
                "templates.edit": "편집하다",
                "templates.delete": "제거하다",
};


